(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cart-drawer_items"] && !Shopify.designMode) return;
  try {
    (function () {
  if (customElements.get('cart-line-toggle')) return;
  customElements.define('cart-line-toggle', class extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      var btn = this.querySelector('.cart-line-toggle__btn');
      if (!btn) return;
      var self = this;
      btn.addEventListener('click', function () {
        var scope = self.closest('.cart-item') || self.parentNode;
        var expanded = self.classList.toggle('is-expanded');
        Array.prototype.forEach.call(scope.querySelectorAll('.cart-line-prop--extra'), function (el) {
          el.classList.toggle('hidden', !expanded);
        });
        var more = self.querySelector('.cart-line-toggle__more');
        var less = self.querySelector('.cart-line-toggle__less');
        if (more) more.classList.toggle('hidden', expanded);
        if (less) less.classList.toggle('hidden', !expanded);
      });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product_personalizer"] && !Shopify.designMode) return;
  try {
    (function () {
  if (customElements.get('product-personalizer')) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function fmtBytesOk(file, maxMb) { return file.size <= maxMb * 1024 * 1024; }
  function isHeic(file) {
    var n = (file.name || '').toLowerCase();
    return /\.(heic|heif)$/.test(n) || file.type === 'image/heic' || file.type === 'image/heif';
  }

  class ProductPersonalizer extends HTMLElement {
    disconnectedCallback() {
      // If the preview panel was moved to <body>, remove it so theme-editor re-renders don't leave orphans.
      if (this._movedPanel && this._movedPanel.parentNode) { this._movedPanel.parentNode.removeChild(this._movedPanel); this._movedPanel = null; }
      if (this._movedGate && this._movedGate.parentNode) { this._movedGate.parentNode.removeChild(this._movedGate); this._movedGate = null; }
      if (this._movedCropper && this._movedCropper.parentNode) { this._movedCropper.parentNode.removeChild(this._movedCropper); this._movedCropper = null; }
      if (this._crop && this._crop.url) { try { URL.revokeObjectURL(this._crop.url); } catch (e) {} this._crop = null; }   // revoke the crop object URL if torn down while the cropper is open
      if (this.fontsEl && this.fontsEl.parentNode === document.body) { this.fontsEl.parentNode.removeChild(this.fontsEl); }
      if (this._ppRO) { this._ppRO.disconnect(); this._ppRO = null; }
      if (this._qtyPoll) { clearInterval(this._qtyPoll); this._qtyPoll = null; }
      var caf = window.cancelAnimationFrame || clearTimeout;
      if (this._mkRaf) { caf(this._mkRaf); this._mkRaf = 0; }
      if (this._clrRaf) { caf(this._clrRaf); this._clrRaf = 0; }
      // Detach document/window listeners so theme-editor section re-renders don't stack them on dead instances.
      if (this._docListeners) { this._docListeners.forEach(function (l) { l.t.removeEventListener(l.e, l.fn, l.opt); }); this._docListeners = null; }
      // Abort in-flight Cloudinary XHRs + neutralize pending retry timers (abortUpload sets _ppSession=0)
      // so a mid-upload theme-editor re-render doesn't leave uploads running against detached DOM.
      if (this.fields) { var ppD = this; this.fields.forEach(function (f) { var w = f.querySelector('.personalizer-upload'); if (w && (w._ppXhr || w.classList.contains('is-uploading'))) ppD.abortUpload(w); }); }
      document.body.style.overflow = '';
    }
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.blockId = this.dataset.blockId;
      this.formId = this.dataset.formId;
      this.form = document.getElementById(this.formId);
      this.maxItems = parseInt(this.dataset.maxItems, 10) || 4;
      this.unitCountOption = (this.dataset.unitCountOption || '').trim();
      this.nameMax = parseInt(this.dataset.nameMax, 10) || 8;
      this.maxMb = parseFloat(this.dataset.maxMb) || 10;
      this.photoRequired = this.dataset.photoRequired === 'true';
      this.nameRequired = this.dataset.nameRequired === 'true';
      this.engravingEnabled = this.dataset.engravingEnabled === 'true';
      this.engravingVariant = (this.dataset.engravingVariant || '').trim();
      this.engravingPerItem = this.dataset.engravingPerItem === 'true';
      this.cardTitleTpl = this.dataset.cardTitle || '';
      this.cardSubTpl = this.dataset.cardSubtitle || '';
      this.photoProp = this.dataset.photoProp || 'Photo';
      this.cloudFallback = this.dataset.cloudFallback !== 'false';
      this.fallbackMsg = this.dataset.fallbackMsg || '';
      this.nameProp = this.dataset.nameProp || 'Name';
      this.engProp = this.dataset.engProp || 'Engraving';
      this.engFontProp = this.dataset.engFontProp || '';   // empty = engraving font picker disabled
      this.engFontPerLine = this.dataset.engFontPerLine === 'true';   // each engraving line picks its own font
      this.fontProp = this.dataset.fontProp || 'Font';
      this.variantData = null;
      var vEl = this.querySelector('script[data-pp-variants]');
      if (vEl) { try { this.variantData = JSON.parse(vEl.textContent); } catch (e) {} }

      this.fields = Array.prototype.slice.call(this.querySelectorAll('.personalizer-field'));
      this.engravingActive = false;
      this.engravings = {};   // slot index -> "L1 || L2" (each item can carry its own message)
      this.engFonts = {};     // slot index -> { '1': {val, fam}, '2': {val, fam} } per-line engraving fonts (single mode uses key '1')
      this._engSlot = 0;

      this.uploadMode = this.dataset.uploadMode || 'shopify';
      this.cloudName = (this.dataset.cloudinaryCloud || '').trim();
      this.cloudPreset = (this.dataset.cloudinaryPreset || '').trim();
      this.cloudFolder = (this.dataset.cloudinaryFolder || '').trim();
      this.cloudinary = this.uploadMode === 'cloudinary' && !!this.cloudName && !!this.cloudPreset;
      this.uploading = 0;
      this.autoResize = this.dataset.autoResize === 'true';
      this.maxDim = parseInt(this.dataset.maxDim, 10) || 2000;
      this.minRes = parseInt(this.dataset.minRes, 10) || 0;
      this.lowResMsg = this.dataset.lowresMsg || '';
      this.mockup = this.querySelector('[data-pp-mockup]');
      this.tiles = this.mockup ? Array.prototype.slice.call(this.mockup.querySelectorAll('[data-pp-tile]')) : [];
      this.tilesEl = this.mockup ? this.mockup.querySelector('[data-pp-mockup-tiles]') : null;
      this.panelEl = this.mockup ? this.mockup.querySelector('[data-pp-mockup-panel]') : null;
      this.colsDesktop = (this.tilesEl && parseInt(this.tilesEl.dataset.colsD, 10)) || 2;
      this.colsMobile = (this.tilesEl && parseInt(this.tilesEl.dataset.colsM, 10)) || 2;
      this._lastShown = 0;
      this.mql = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
      this.mockupMode = (this.mockup && this.mockup.dataset.mode) || 'inline';
      this._singleIndex = null;
      this.mockupStyle = this.dataset.mockupStyle || 'photo';
      this.mockupEffect = (this.dataset.mockupEffect || '').trim();
      this.mockupRemoveBg = this.dataset.mockupRemovebg === 'true';
      this.mockupDefaultImg = (this.mockup && this.mockup.dataset.default) || '';
      // Auto-keep the name below the pet photo: push it down just enough so no font/photo ever overlaps.
      this.nameClearance = !!(this.mockup && this.mockup.dataset.nameClearance !== 'false');
      this.nameGap = (this.mockup && parseFloat(this.mockup.dataset.nameGap)) || 0;
      this.nameGapMobile = this.mockup ? parseFloat(this.mockup.dataset.nameGapM) : NaN;
      if (isNaN(this.nameGapMobile)) this.nameGapMobile = this.nameGap;
      this.mockupShape = (this.mockup && this.mockup.dataset.shape) || 'circle';
      // Material -> mockup image map (matched generically against the selected variant's option values).
      this.matMap = {};
      if (this.mockup) {
        // Read ALL data-mat{N}-value / data-mat{N}-img pairs (any count) -> generic material map.
        var mds = this.mockup.dataset, mm = this.matMap;
        Object.keys(mds).forEach(function (k) {
          var m = k.match(/^mat(\d+)Value$/);
          if (!m) return;
          var img = mds['mat' + m[1] + 'Img'];
          if (mds[k] && img) mm[mds[k]] = img;   // exact key: the value exactly as entered (case/space sensitive)
        });
      }
      // Fallback base: no default mockup image but materials set -> use the first material image as the base.
      if (!this.mockupDefaultImg) { var mk0 = Object.keys(this.matMap); if (mk0.length) this.mockupDefaultImg = this.matMap[mk0[0]]; }
      var ppSelf = this;
      if (this.mql && this.mql.addEventListener) this._bindDoc(this.mql, 'change', function () { ppSelf.layoutTiles(ppSelf._lastShown || 1); ppSelf.refreshNameClearance(); });
      if (this.mockup && (this.mockupMode === 'button' || this.mockupMode === 'button_each')) {
        Array.prototype.forEach.call(this.mockup.querySelectorAll('[data-pp-mockup-close]'), function (c) { c.addEventListener('click', function () { ppSelf.closeMockupModal(); }); });
        ppSelf._bindDoc(document, 'keydown', function (e) { if ((e.key === 'Escape' || e.keyCode === 27) && ppSelf.panelEl && ppSelf.panelEl.classList.contains('is-open')) ppSelf.closeMockupModal(); });
      }
      if (this.mockup && this.mockupMode === 'button') {
        var mkOpen = this.mockup.querySelector('[data-pp-mockup-open]');
        if (mkOpen) mkOpen.addEventListener('click', function () { ppSelf.openMockupModal(); });
      }
      if (this.mockup && this.mockupMode === 'button_each') {
        Array.prototype.forEach.call(this.querySelectorAll('[data-pp-preview-one]'), function (btn) {
          btn.addEventListener('click', function () { ppSelf.openMockupModal((parseInt(btn.dataset.index, 10) || 1) - 1); });
        });
      }
      this.tiles.forEach(function (tile) {
        // The base pendant image sets the stage height (height:auto, lazy). Until it decodes the
        // stage is ~0px and clearance can't measure — re-run once it loads so the name settles.
        var baseImg = tile.querySelector('[data-pp-tile-base]');
        if (baseImg) baseImg.addEventListener('load', function () { ppSelf.refreshNameClearance(); });
        var ph = tile.querySelector('[data-pp-tile-photo]');
        if (!ph) return;
        ph.addEventListener('load', function () { tile.classList.remove('is-loading'); });
        ph.addEventListener('error', function () {
          var t = (ph._ppTry || 0) + 1; ph._ppTry = t;
          // Cloudinary AI background removal still processing -> poll (quick at first, then back off).
          var delays = [700, 1100, 1700, 2500, 3500];
          if (t <= delays.length && ph._ppSrc) { var want = ph._ppSrc; setTimeout(function () { if (ph._ppSrc === want && !ph.hidden && !tile.hidden && ph.isConnected) ph.src = want + '?ppr=' + t; }, delays[t - 1]); }
          else { tile.classList.remove('is-loading'); if (ph._ppPlain && ph.getAttribute('src') !== ph._ppPlain) ph.src = ph._ppPlain; }
        });
      });
      if (this.tiles.length) {
        ppSelf._bindDoc(document, 'change', function (e) {
          var n = e.target && e.target.name;
          if (n && (/^options\[/.test(n) || n === 'id' || n === 'quantity')) {
            ppSelf.scheduleMockup();
            setTimeout(function () { ppSelf.scheduleMockup(); }, 60);   // 2nd pass catches async <variant-selects> id updates
          }
        });
        // The name scale (--pp-nscale) and clearance shift are px/measurement based; recompute them
        // when the preview box changes size (window resize, reflow, breakpoints that don't cross 749px).
        if ('ResizeObserver' in window && this.tilesEl) {
          var rzT; this._ppRO = new ResizeObserver(function () {
            if (rzT) clearTimeout(rzT);
            rzT = setTimeout(function () { ppSelf.layoutTiles(ppSelf._lastShown || 1); ppSelf.refreshNameClearance(); }, 120);
          });
          this._ppRO.observe(this.tilesEl);
        }
      }
      this.cropEnabled = this.dataset.cropEnable === 'true';
      this.cropInitialZoom = Math.max(1, Math.min(3, (parseFloat(this.dataset.cropZoom) || 120) / 100));

      this.setupNames();
      this.setupUploads();
      this.setupCropper();
      this.setupEngraving();
      this.bindQuantity();
      this.applyQuantity(this.currentQty());
      this.bindSubmit();
      this.setupGate();
      this.setupFonts();
      this.updateMockup();
    }

    /* ---------- Quantity (Bundle & Save Buy 1/2/3/4) ---------- */
    currentQty() {
      if (!this.unitCountOption) {
        var c0 = document.querySelector('input[name="quantity"]:checked');
        var q0 = c0 ? parseInt(c0.value, 10) : 1;
        return q0 && q0 > 0 ? q0 : 1;
      }
      return this.totalUnitCount();
    }
    totalUnitCount() {
      // 1. Bundle (quantity-breaks block with per-unit variant selects) -> sum across units.
      var b = this.bundleUnitCountSum();
      if (b > 0) return b;
      // 2. Single product: the selected variant's per-unit count value (works for ANY count picker style:
      //    dropdown, pills/swatches, OR "Quantity breaks" cards in the Variant picker).
      var sv = this.selectedVariantUnitCount();
      if (sv > 0) return sv;
      // 3. Fallback: a checked count input (cards) or a standalone select.
      var p = this.unitCountInputValue();
      if (p > 0) return p;
      var checked = document.querySelector('input[name="quantity"]:checked');
      var q = checked ? parseInt(checked.value, 10) : 1;
      return q && q > 0 ? q : 1;
    }
    bundleUnitCountSum() {
      var checked = document.querySelector('input[name="quantity"]:checked');
      var label = checked ? checked.nextElementSibling : null;
      if (!label || !label.querySelectorAll) return 0;
      var sels = label.querySelectorAll('select[name="options[' + this.unitCountOption + ']"]');
      if (!sels.length) return 0;
      var total = 0;
      Array.prototype.forEach.call(sels, function (s) { total += parseInt(s.value, 10) || 0; });
      return total;
    }
    selectedVariantUnitCount() {
      if (!this.variantData || !this.variantData.variants) return 0;
      var hid = this.form && this.form.querySelector('[name="id"]');
      var vid = hid ? parseInt(hid.value, 10) : 0;
      if (!vid) return 0;
      var cIdx = (this.variantData.options || []).indexOf(this.unitCountOption);
      if (cIdx < 0) return 0;
      var vs = this.variantData.variants;
      for (var i = 0; i < vs.length; i++) {
        if (vs[i].id === vid) return parseInt((vs[i].o || [])[cIdx], 10) || 0;
      }
      return 0;
    }
    unitCountInputValue() {
      // "Quantity breaks" variant cards render <input name="<Option>" ...:checked>.
      var r = document.querySelector('input[name="' + this.unitCountOption + '"]:checked');
      if (r) { var rv = parseInt(r.value, 10); if (rv > 0) return rv; }
      // dropdown / pills / swatches render <select name="options[<Option>]"> (outside any bundle).
      var all = document.querySelectorAll('select[name="options[' + this.unitCountOption + ']"]');
      for (var i = 0; i < all.length; i++) {
        if (!all[i].closest('quantity-breaks')) { var sv = parseInt(all[i].value, 10); if (sv > 0) return sv; }
      }
      return 0;
    }
    bindQuantity() {
      var self = this;
      this._lastCount = -1;
      this._pendingOptimistic = null;
      this._optTime = 0;
      var tick = function () {
        var n = self.currentQty();
        if (self._pendingOptimistic != null) {
          if (n === self._pendingOptimistic) { self._pendingOptimistic = null; }   // real sum caught up
          else if (performance.now() - self._optTime < 1300) { return; }            // still propagating: hold optimistic
          else { self._pendingOptimistic = null; }                                  // timed out: accept the real sum
        }
        if (n === self._lastCount) return;
        self._lastCount = n;
        self.applyQuantity(n);
      };
      this._tick = tick;
      var burst = function () {
        tick();
        if (window.requestAnimationFrame) requestAnimationFrame(tick);
        setTimeout(tick, 0);
        setTimeout(tick, 120);
        setTimeout(tick, 300);
      };
      self._bindDoc(document, 'change', function (e) {
        var t = e.target;
        if (!t || !t.name) return;
        if (!self.unitCountOption) { if (t.name === 'quantity') burst(); return; }
        var isQty = t.name === 'quantity';
        var isCountSelect = t.name === 'options[' + self.unitCountOption + ']';
        // "Quantity breaks" variant cards render <input name="<CountOption>">; the Variant picker also
        // re-renders on any variant option change. Catch anything inside <variant-selects> too.
        var inVariant = t.closest && t.closest('variant-selects');
        if (!isQty && !isCountSelect && !inVariant) return;

        if (isCountSelect && t.closest('quantity-breaks')) {
          // One unit's count changed directly -> the real per-unit sum is already correct.
          self._pendingOptimistic = null;
          burst();
          return;
        }

        // Bundle & Save tier change OR the standalone count dropdown. ASSUMPTION (Bundle & Save app
        // behavior, NOT product-specific): the bundle replicates the standalone per-unit count onto
        // EVERY unit in the tier ASYNCHRONOUSLY (~0.8s). Show standalone*N instantly (optimistic) so
        // the customer never waits; the 1300ms poll converges to the real sum (no flicker). A bundle
        // app with heterogeneous per-unit counts still self-corrects once the poll catches up.
        var hasBundle = !!document.querySelector('input[name="quantity"]');
        if (hasBundle && (isQty || isCountSelect)) {
          var sa = self.unitCountInputValue() || 1;
          var checked = document.querySelector('input[name="quantity"]:checked');
          var N = checked ? (parseInt(checked.value, 10) || 1) : 1;
          var target = sa * N;
          self._pendingOptimistic = target;
          self._optTime = performance.now();
          self._lastCount = target;
          self.applyQuantity(target);
          setTimeout(tick, 150);
          setTimeout(tick, 500);
          setTimeout(tick, 1000);
          return;
        }

        // Single product (no bundle): a count card / variant change. <variant-selects> updates the
        // form's name="id" (sometimes after an async re-render) -> burst now + the 250ms poll converges.
        self._pendingOptimistic = null;
        burst();
      });
      // Light safety-net poll (the per-change setTimeouts above do the fast convergence; this only
      // catches async Bundle&Save / variant re-renders). Slow, pauses when the tab is hidden, and is
      // cleared on disconnect so theme-editor re-renders don't stack intervals.
      if (this.unitCountOption) {
        this._qtyPoll = setInterval(function () { if (document.visibilityState !== 'hidden') tick(); }, 1000);
      }
    }
    applyQuantity(n) {
      this.activeCount = Math.min(Math.max(1, n), this.maxItems);
      var self = this;
      this.fields.forEach(function (f, idx) {
        var active = idx < self.activeCount;
        f.hidden = !active;
        Array.prototype.forEach.call(f.querySelectorAll('input'), function (inp) {
          if (inp.hasAttribute('data-pp-photo-url')) {
            inp.disabled = !active || !inp.value;
          } else {
            inp.disabled = !active;
          }
        });
      });
      this.updateEngravingLabel();
      this.scheduleMockup();
    }

    // Keyboard focus trap for a modal dialog: move focus in on open, keep Tab inside, return focus on close.
    _trapFocus(container) {
      if (!container) return;
      this._releaseFocus();   // in case another dialog was open
      this._focusReturn = document.activeElement;
      var sel = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
      var visible = function () { return Array.prototype.slice.call(container.querySelectorAll(sel)).filter(function (el) { return !el.hasAttribute('hidden') && el.offsetParent !== null; }); };
      var f0 = visible()[0];
      if (f0) { try { f0.focus(); } catch (e) {} }
      else { try { container.setAttribute('tabindex', '-1'); container.focus(); } catch (e) {} }
      this._trapContainer = container;
      this._trapHandler = function (e) {
        if (e.key !== 'Tab' && e.keyCode !== 9) return;
        var f = visible(); if (!f.length) return;
        var a = f[0], b = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); b.focus(); }
        else if (!e.shiftKey && document.activeElement === b) { e.preventDefault(); a.focus(); }
      };
      container.addEventListener('keydown', this._trapHandler);
    }
    _releaseFocus() {
      if (this._trapContainer && this._trapHandler) this._trapContainer.removeEventListener('keydown', this._trapHandler);
      this._trapHandler = null; this._trapContainer = null;
      if (this._focusReturn && this._focusReturn.focus) { try { this._focusReturn.focus(); } catch (e) {} }
      this._focusReturn = null;
    }

    // Register a document/window listener AND remember it so disconnectedCallback can detach it
    // (prevents leaks when the theme editor re-renders the section).
    _bindDoc(target, event, fn, opt) {
      target.addEventListener(event, fn, opt);
      (this._docListeners = this._docListeners || []).push({ t: target, e: event, fn: fn, opt: opt });
    }

    // Coalesce bursty preview/clearance work into one animation frame (typing, variant/qty change
    // fire these many times in a row) — keeps interaction smooth on mid-range phones.
    scheduleMockup() {
      var self = this;
      if (this._mkRaf) return;
      this._mkRaf = (window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); })(function () { self._mkRaf = 0; self.updateMockup(); });
    }
    scheduleClearance() {
      var self = this;
      if (this._clrRaf) return;
      this._clrRaf = (window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); })(function () { self._clrRaf = 0; self.refreshNameClearance(); });
    }

    /* ---------- Name counters ---------- */
    setupNames() {
      var self = this;
      this.fields.forEach(function (f, idx) {
        var input = f.querySelector('[data-pp-name]');
        var counter = f.querySelector('[data-pp-name-counter]');
        if (!input || !counter) return;
        var preview = f.querySelector('[data-pp-name-preview]');
        var update = function () {
          counter.textContent = input.value.length + '/' + self.nameMax;
          self.updateTileName(idx);
          self.scheduleClearance();   // taller/shorter glyphs change the needed gap (coalesced per frame)
          if (preview) { var v = input.value.trim(); preview.textContent = v; if (v) preview.removeAttribute('hidden'); else preview.setAttribute('hidden', ''); }
        };
        input.addEventListener('input', update);
        update();
      });
    }

    /* ---------- Photo uploads (click, drag-drop, preview, progress) ---------- */
    setupUploads() {
      var self = this;
      this.fields.forEach(function (f) {
        var wrap = f.querySelector('.personalizer-upload');
        var input = f.querySelector('[data-pp-file]');
        var area = f.querySelector('[data-pp-droparea]');
        if (!wrap || !input || !area) return;

        ['dragenter', 'dragover'].forEach(function (ev) {
          area.addEventListener(ev, function (e) { e.preventDefault(); wrap.classList.add('is-dragover'); });
        });
        ['dragleave', 'dragend', 'drop'].forEach(function (ev) {
          area.addEventListener(ev, function (e) { e.preventDefault(); wrap.classList.remove('is-dragover'); });
        });
        area.addEventListener('drop', function (e) {
          if (!e.dataTransfer || !e.dataTransfer.files || !e.dataTransfer.files.length) return;
          input.files = e.dataTransfer.files;
          self.handleFile(wrap, input, f);
        });
        input.addEventListener('change', function () { self.handleFile(wrap, input, f); });

        var removeBtn = f.querySelector('[data-pp-remove]');
        if (removeBtn) removeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          input.value = '';
          self.resetUpload(wrap, f);
        });
      });
    }

    resetUpload(wrap, field) {
      this.abortUpload(wrap);
      this.hideRetry(wrap);
      wrap._ppFailed = false;   // a removed photo is no longer "failed" — validate() must not keep blocking add-to-cart
      wrap._ppPick = (wrap._ppPick || 0) + 1;   // invalidate any in-flight decode/resize callback from a removed/superseded pick
      wrap.classList.remove('has-file', 'is-uploading', 'is-uploaded');
      if (wrap._objUrl) { try { URL.revokeObjectURL(wrap._objUrl); } catch (e) {} wrap._objUrl = null; }
      this.show(wrap.querySelector('[data-pp-placeholder]'));
      this.hide(wrap.querySelector('[data-pp-preview]'));
      this.hide(wrap.querySelector('[data-pp-remove]'));
      this.hide(wrap.querySelector('[data-pp-progress]'));
      this.hide(wrap.querySelector('[data-pp-status]'));
      this.hide(wrap.querySelector('[data-pp-ring]'));
      this.hide(wrap.querySelector('[data-pp-file-error]'));
      if (field) {
        var u = field.querySelector('[data-pp-photo-url]');
        if (u) { u.value = ''; u.disabled = true; }
        var fi = field.querySelector('[data-pp-file]');
        if (fi) {
          try { fi.value = ''; } catch (e) {}
          // Undo a Cloudinary native-fallback rename so a fresh pick starts clean.
          if (wrap._ppNativeFallback) {
            if (fi._ppOrigName) fi.name = fi._ppOrigName; else fi.removeAttribute('name');
            if (fi._ppOrigForm) fi.setAttribute('form', fi._ppOrigForm); else fi.removeAttribute('form');
          }
        }
      }
      wrap._ppNativeFallback = false;
      this.updateMockup();
    }

    handleFile(wrap, input, field) {
      var self = this;
      var errEl = wrap.querySelector('[data-pp-file-error]');
      this.hide(errEl);
      this.hideWarn(wrap);
      if (!input.files || !input.files.length) { this.resetUpload(wrap, field); return; }
      var file = input.files[0];

      wrap.classList.add('has-file');
      // Session token for the async decode/resize window: if Remove is clicked or a different file is
      // re-picked before these callbacks fire, the stale callback must not upload the old photo (UP-1).
      var pick = (wrap._ppPick = (wrap._ppPick || 0) + 1);
      function stale() { return wrap._ppPick !== pick; }
      this.hide(wrap.querySelector('[data-pp-placeholder]'));
      this.show(wrap.querySelector('[data-pp-remove]'));

      var img = wrap.querySelector('[data-pp-preview-img]');
      var chip = wrap.querySelector('[data-pp-file-chip]');
      var preview = wrap.querySelector('[data-pp-preview]');

      function tooLargeStop() {
        input.value = '';
        self.resetUpload(wrap, field);
        errEl.textContent = 'File is too large (max ' + self.maxMb + 'MB).';
        self.show(errEl);
      }
      function upload(payload) { if (self.cloudinary) self.uploadToCloudinary(payload, wrap, field); else self.applyNativeFile(payload, wrap, field); }

      // HEIC: browsers can't decode it for resize/preview/crop — keep the original (Cloudinary converts it).
      if (isHeic(file)) {
        if (!fmtBytesOk(file, this.maxMb)) { tooLargeStop(); return; }
        // Let the shopper know an iPhone HEIC skips the crop step (so they aren't surprised it wasn't cropped).
        if (this.cropEnabled) this.showWarn(wrap, this.heicNoCropMsg || 'HEIC (iPhone) photos are uploaded without cropping.');
        this.hide(img); chip.textContent = file.name; this.show(chip); this.show(preview);
        upload(file);
        return;
      }

      // JPEG/PNG: instant preview, then resize oversized photos so they never fail and upload fast.
      if (wrap._objUrl) { try { URL.revokeObjectURL(wrap._objUrl); } catch (e) {} }
      wrap._objUrl = URL.createObjectURL(file);
      this.hide(chip); img.src = wrap._objUrl; this.show(img); this.show(preview);
      this.updateMockup();

      if (this.cropEnabled) { this.openCropper(file, wrap, field); return; }

      var probe = new Image();
      probe.onload = function () {
        if (stale()) return;
        var w = probe.naturalWidth, h = probe.naturalHeight, small = Math.min(w, h);
        if (self.minRes && small > 0 && small < self.minRes) self.showWarn(wrap, self.lowResMsg);
        var needsResize = self.autoResize && (Math.max(w, h) > self.maxDim || file.size > self.maxMb * 1024 * 1024);
        if (needsResize) {
          self.resizeToBlob(probe, w, h, self.maxDim, function (blob) {
            if (stale()) return;
            if (blob) {
              var out = self.namedFile(blob, file.name);
              if (!fmtBytesOk(out, self.maxMb)) { tooLargeStop(); return; }   // UP-3: recheck the RESIZED blob so an over-cap output never reaches upload
              upload(out); return;
            }
            if (!fmtBytesOk(file, self.maxMb)) { tooLargeStop(); return; }
            upload(file);
          });
        } else {
          if (!fmtBytesOk(file, self.maxMb)) { tooLargeStop(); return; }
          upload(file);
        }
      };
      probe.onerror = function () {
        if (stale()) return;
        if (!fmtBytesOk(file, self.maxMb)) { tooLargeStop(); return; }
        upload(file);
      };
      probe.src = wrap._objUrl;
    }

    resizeToBlob(im, w, h, maxDim, cb) {
      try {
        var scale = Math.min(1, maxDim / Math.max(w, h));
        var nw = Math.max(1, Math.round(w * scale)), nh = Math.max(1, Math.round(h * scale));
        var canvas = document.createElement('canvas');
        canvas.width = nw; canvas.height = nh;
        canvas.getContext('2d').drawImage(im, 0, 0, nw, nh);
        if (canvas.toBlob) canvas.toBlob(function (b) { cb(b); }, 'image/jpeg', 0.9);
        else cb(null);
      } catch (e) { cb(null); }
    }

    // Wrap a processed canvas Blob in a named File so Cloudinary/the order keep the customer's filename.
    namedFile(blob, origName) {
      if (!blob) return blob;
      try {
        if (typeof File === 'function') {
          var base = String(origName || 'photo').replace(/\.[^.]+$/, '') || 'photo';
          return new File([blob], base + '.jpg', { type: blob.type || 'image/jpeg' });
        }
      } catch (e) {}
      return blob;
    }

    showWarn(wrap, msg) {
      if (!msg) return;
      var el = wrap.querySelector('[data-pp-warn]');
      if (el) { el.textContent = msg; el.hidden = false; }
    }
    hideWarn(wrap) {
      var el = wrap.querySelector('[data-pp-warn]');
      if (el) el.hidden = true;
    }

    // Live product preview: mirror the first photo onto the mockup image.
    // Generic: the mockup image for the currently selected variant's material (matched by option value), else default.
    selectedMaterialImage() {
      var keys = this.matMap ? Object.keys(this.matMap) : [];
      if (keys.length && this.variantData && this.form) {
        var hid = this.form.querySelector('[name="id"]');
        var vid = hid ? parseInt(hid.value, 10) : 0;
        var vs = (this.variantData && this.variantData.variants) || [];
        for (var i = 0; i < vs.length; i++) {
          if (vs[i].id === vid) {
            var o = vs[i].o || [];
            for (var j = 0; j < o.length; j++) { if (this.matMap[o[j]]) return this.matMap[o[j]]; }   // exact match only
            break;
          }
        }
      }
      return this.mockupDefaultImg || '';
    }

    effectSrc(blobSrc, cloudUrl) {
      var src = blobSrc || '';
      var tx = [];
      if (this.mockupRemoveBg) tx.push('e_background_removal');
      if (this.mockupStyle === 'engraving' && this.mockupEffect) tx.push(this.mockupEffect);
      if (this.mockupRemoveBg) tx.push('f_png');
      if (cloudUrl && tx.length) src = cloudUrl.replace('/upload/', '/upload/' + tx.join('/') + '/');
      return src;
    }

    openMockupModal(index) {
      if (!this.mockup || !this.panelEl) return;
      this._singleIndex = (typeof index === 'number' && index >= 0) ? index : null;
      // Move the panel to <body> so position:fixed escapes any transformed ancestor (true full-screen overlay).
      if (this.panelEl.parentNode !== document.body) { document.body.appendChild(this.panelEl); this._movedPanel = this.panelEl; }
      this.panelEl.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this._trapFocus(this.panelEl);
      this.updateMockup();
      var ppSelf = this;   // panel was display:none until now — re-measure clearance once it's laid out
      if (window.requestAnimationFrame) requestAnimationFrame(function () { ppSelf.refreshNameClearance(); });
    }
    closeMockupModal() {
      this._singleIndex = null;
      this._releaseFocus();
      if (this.panelEl) this.panelEl.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // Per-field preview buttons: show one only when its field has an uploaded photo.
    updatePreviewButtons() {
      for (var b = 0; b < this.fields.length; b++) {
        var fb = this.fields[b];
        var btn = fb && fb.querySelector('[data-pp-preview-one]');
        if (!btn) continue;
        var w = fb.querySelector('.personalizer-upload');
        btn.hidden = !(w && w.classList.contains('has-file') && !fb.hidden);
      }
    }

    // Set the grid column count = min(configured columns for this viewport, number of visible previews).
    layoutTiles(shown) {
      if (!this.tilesEl) return;
      var isMobile = this.mql ? this.mql.matches : (window.innerWidth <= 749);
      var maxCols = (isMobile ? this.colsMobile : this.colsDesktop) || 1;
      var cols = Math.max(1, Math.min(maxCols, shown || 1));
      this.tilesEl.style.gridTemplateColumns = 'repeat(' + cols + ', minmax(0, 1fr))';
      var W = this.tilesEl.clientWidth || 0;
      // --pp-nscale keeps the name proportional across COLUMN counts (each column packs a smaller tile).
      var scale = 1;
      if (cols > 1) {
        var vis = null;
        if (this.tiles) { for (var k = 0; k < this.tiles.length; k++) { if (!this.tiles[k].hidden) { vis = this.tiles[k]; break; } } }
        var tw = vis ? vis.getBoundingClientRect().width : 0;
        scale = (W > 0 && tw > 0) ? Math.min(1, tw / W) : 1 / cols;
      }
      this.tilesEl.style.setProperty('--pp-nscale', scale.toFixed(4));
      // --pp-vpscale keeps the name proportional across VIEWPORTS/DEVICES: the pendant row is a % of the
      // column, so its px width changes with the device (2-column tablet ≈300px, wide desktop ≈500px,
      // phone 1-column ≈ viewport). A fixed-px name would look too big on narrow pendants (overflow) and
      // too small on wide ones. Shrink the name when the row is narrower than a reference, capped at 1 so
      // the merchant's size is never exceeded. Separate references: desktop/tablet bucket vs phone bucket
      // (each has its own Name size). Uses the ROW width, so 1 photo and many photos get the SAME vpscale
      // (only --pp-nscale differs by column count) → single- and multi-pendant previews always match.
      var REF = isMobile ? 340 : 520;
      var vp = (W <= 0) ? 1 : Math.min(1, W / REF);
      this.tilesEl.style.setProperty('--pp-vpscale', vp.toFixed(4));
    }

    // Render one preview tile per uploaded photo (works for any product: uses the personalizer's own fields).
    updateMockup() {
      if (!this.mockup || !this.tiles || !this.tiles.length) return;
      if (this.mockupMode === 'button_each') this.updatePreviewButtons();
      var single = (this._singleIndex == null) ? -1 : this._singleIndex;
      var matImg = this.selectedMaterialImage();
      var shown = 0;
      for (var i = 0; i < this.tiles.length; i++) {
        var tile = this.tiles[i];
        if (single >= 0 && i !== single) { tile.hidden = true; var phx = tile.querySelector('[data-pp-tile-photo]'); if (phx) phx.hidden = true; continue; }
        var field = this.fields[i];
        var wrap = field && field.querySelector('.personalizer-upload');
        var photo = tile.querySelector('[data-pp-tile-photo]');
        var hasFile = !!(wrap && wrap.classList.contains('has-file') && !field.hidden);
        if (!hasFile) { tile.hidden = true; if (photo) { photo.removeAttribute('src'); photo.hidden = true; } continue; }
        var previewImg = field.querySelector('[data-pp-preview-img]');
        var urlInput = field.querySelector('[data-pp-photo-url]');
        var src = this.effectSrc(previewImg ? previewImg.getAttribute('src') : '', urlInput ? urlInput.value : '');
        if (!src) { tile.hidden = true; continue; }
        var base = tile.querySelector('[data-pp-tile-base]');
        if (base && matImg && base.getAttribute('src') !== matImg) base.src = matImg;
        if (photo) {
          if (photo.getAttribute('src') !== src) {
            photo._ppSrc = src;
            photo._ppPlain = (urlInput && urlInput.value) || (previewImg && previewImg.getAttribute('src')) || '';
            photo._ppTry = 0;
            tile.classList.add('is-loading');
            photo.src = src;
          }
          photo.hidden = false;
        }
        this.updateTileName(i);
        tile.hidden = false;
        shown++;
      }
      var design = window.Shopify && window.Shopify.designMode;
      if (shown === 0 && design) {
        var t0 = this.tiles[0];
        if (t0) {
          var b0 = t0.querySelector('[data-pp-tile-base]');
          if (b0 && matImg && b0.getAttribute('src') !== matImg) b0.src = matImg;
          var p0 = t0.querySelector('[data-pp-tile-photo]'); if (p0) { p0.removeAttribute('src'); p0.hidden = true; }
          var n0 = t0.querySelector('[data-pp-tile-name]'); var nb0 = t0.querySelector('[data-pp-tile-name-box]') || n0; if (n0) { if (!n0.textContent) n0.textContent = 'Name'; if (nb0) nb0.removeAttribute('hidden'); }
          t0.hidden = false;
        }
        this.mockup.classList.add('pp-mk-design'); if (this.panelEl) this.panelEl.classList.add('pp-mk-design');   // editor-only photo-position guide ring
        this.mockup.classList.add('is-shown');
        this._lastShown = 1; this.layoutTiles(1); this.refreshNameClearance();
        return;
      }
      this.mockup.classList.remove('pp-mk-design'); if (this.panelEl) this.panelEl.classList.remove('pp-mk-design');
      this._lastShown = shown;
      // Reveal BEFORE measuring: on the first upload the wrapper is still display:none, so
      // layoutTiles would read width 0 (name flashes at full size until the ResizeObserver pass).
      if (shown > 0) this.mockup.classList.add('is-shown');
      else if (!design) this.mockup.classList.remove('is-shown');
      this.layoutTiles(shown);
      this.refreshNameClearance();
    }

    updateTileName(i) {
      if (!this.tiles || !this.tiles[i]) return;
      var textEl = this.tiles[i].querySelector('[data-pp-tile-name]');
      if (!textEl) return;
      var box = this.tiles[i].querySelector('[data-pp-tile-name-box]') || textEl;
      var field = this.fields[i];
      var input = field && field.querySelector('[data-pp-name]');
      var name = (input && input.value) ? input.value.trim() : '';
      textEl.textContent = name;
      if (name) box.removeAttribute('hidden'); else box.setAttribute('hidden', '');
    }

    /* Keep the name below the pet photo: push it down only as much as needed so any font
       (tall scripts included) and any photo size never overlap. No-op when there is already
       enough room, so a well-spaced layout (and the editor placeholder) is left unchanged. */
    refreshNameClearance() {
      if (!this.nameClearance || !this.tiles) return;
      for (var i = 0; i < this.tiles.length; i++) {
        var t = this.tiles[i];
        if (t.hidden) { var hb = t.querySelector('[data-pp-tile-name-box]'); if (hb) hb.style.setProperty('--mn-yshift', '0px'); }   // clear any stale shift on hidden tiles
        else this.adjustNameClearance(t);
      }
    }

    adjustNameClearance(tile) {
      var box = tile.querySelector('[data-pp-tile-name-box]');
      if (!box) return;
      box.style.setProperty('--mn-yshift', '0px');   // reset before measuring the base position
      var photo = tile.querySelector('[data-pp-tile-photo]');
      if (!this.nameClearance || box.hasAttribute('hidden') || !photo || photo.hidden || !photo.getAttribute('src')) return;
      var stage = tile.querySelector('.personalizer-mockup__stage') || tile;
      var sRect = stage.getBoundingClientRect();
      if (!sRect.height) return;                      // stage not laid out yet (e.g. closed modal)
      var pRect = photo.getBoundingClientRect();
      // Measure the name's real glyph ink (SVG <text> for curved, the span for straight) so a
      // tall script capital is accounted for, not just the box.
      var ink = (box.tagName && box.tagName.toLowerCase() === 'svg') ? (box.querySelector('text') || box) : box;
      var nRect = ink.getBoundingClientRect();
      if (!nRect.height || !nRect.width) return;
      // A curved name's ENDS rise above its centre. Beside a round photo those raised ends sit next
      // to the disc (where the circle curves up), NOT under it — so measuring from the box top over-
      // reports overlap and shoves the name too far down. Use an effective top nearer the name's
      // centre, scaled by how strong the curve is (curve 0 = box top, curve 50 = box centre).
      var curve = parseFloat(box.getAttribute && box.getAttribute('data-pp-curve')) || 0;
      var effTop = nRect.top + nRect.height * 0.5 * Math.min(1, curve / 50);
      // Find the photo's lower edge DIRECTLY UNDER the name's centre. Doing it from the real geometry
      // makes the push exact for ANY photo-circle setting: move it sideways / up-down / resize it and
      // the reference tracks the actual disc edge under the name (and if the name centre is off past
      // the disc, there is nothing to clear so it never pushes).
      var nameCx = (nRect.left + nRect.right) / 2;
      var pcx = (pRect.left + pRect.right) / 2, pcy = (pRect.top + pRect.bottom) / 2;
      var boundary;
      if (this.mockupShape === 'circle') {
        var rr = Math.min(pRect.width, pRect.height) / 2;
        var dx = nameCx - pcx;
        if (Math.abs(dx) >= rr) return;                 // name centre is beyond the disc — nothing under it
        boundary = pcy + Math.sqrt(rr * rr - dx * dx);  // the circle's lower edge at the name's x
      } else {
        if (nameCx <= pRect.left || nameCx >= pRect.right) return;   // name centre not over the photo box
        boundary = pRect.bottom;                        // square / rounded: clear the box bottom
      }
      // Only push a name that sits BELOW the photo centre (never drag a name placed above/beside it).
      if ((nRect.top + nRect.height / 2) <= pcy) return;
      var gapPct = (this.mql && this.mql.matches) ? this.nameGapMobile : this.nameGap;
      var gapPx = (gapPct / 100) * sRect.height;
      var overlap = (boundary + gapPx) - effTop;        // >0 => name intrudes into the photo (+ gap)
      if (overlap <= 0) return;
      var maxShift = (sRect.bottom - 2) - nRect.bottom;   // never push the name off the pendant's bottom rim
      var shift = Math.max(0, Math.min(overlap, maxShift));
      if (shift > 0.5) box.style.setProperty('--mn-yshift', shift.toFixed(1) + 'px');
    }

    /* ---------- Customer font picker (one shared chart, a pick PER pendant) ---------- */
    setupFonts() {
      this.fontsEl = this.querySelector('[data-pp-fonts]');
      this.fontPicks = Array.prototype.slice.call(this.querySelectorAll('[data-pp-fontpick]'));
      var engModalEl = this.engFontProp ? document.getElementById('PersonalizerEngravingModal-' + this.blockId) : null;
      var engBtns = engModalEl ? Array.prototype.slice.call(engModalEl.querySelectorAll('[data-eng-font-open]')) : [];
      var engBtn = engBtns[0] || null;
      if (!this.fontsEl || (!this.fontPicks.length && !engBtn)) return;
      var self = this, grid = this.fontsEl;
      var opts = Array.prototype.slice.call(grid.querySelectorAll('[data-pp-font]'));
      var customBtn = grid.querySelector('[data-pp-font-custom-btn]');
      var noneBtn = grid.querySelector('[data-pp-font-none]');
      var customInput = grid.querySelector('[data-pp-font-custom]');
      var samples = Array.prototype.slice.call(grid.querySelectorAll('[data-pp-font] .personalizer-fonts__sample'));
      var head = grid.querySelector('[data-pp-font-head]');
      var headBase = head ? head.textContent : '';
      var fontDefault = (samples[0] && samples[0].textContent) || 'Bella';
      this._activeFontIdx = -1;   // 0-based tile index the shared chart currently targets
      this._fontTarget = 'name';  // 'name' = a pendant's name font | 'eng' = the engraving font for _engSlot
      this._engFontLine = '1';    // which engraving line ('1'/'2') the chart currently targets in per-line mode

      // Lazy-load the shared web-font stylesheet once, when any trigger nears the viewport.
      var loaded = false;
      var loadFonts = function () {
        if (loaded) return; loaded = true;
        var url = grid.getAttribute('data-font-url'); if (!url) return;
        var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = url; document.head.appendChild(l);
      };
      self._loadChartFonts = loadFonts;   // reopening a modal with a saved engraving font needs the families too
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (ents) { ents.forEach(function (e) { if (e.isIntersecting) { loadFonts(); io.disconnect(); } }); }, { rootMargin: '300px' });
        this.fontPicks.forEach(function (p) { io.observe(p); });
        var engCard = engBtn && this.querySelector('[data-engraving-card]');
        if (engCard) io.observe(engCard);   // engraving trigger lives inside a closed modal — preload from the card instead
      } else { loadFonts(); }
      if (document.fonts && document.fonts.addEventListener) { self._bindDoc(document.fonts, 'loadingdone', function () { self.refreshNameClearance(); }); }

      function pickEl() { return (self._activeFontIdx >= 0) ? self.fontPicks[self._activeFontIdx] : null; }
      function valueInputOf(p) { return p && p.querySelector('[data-pp-font-value]'); }
      function clearActive() { opts.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-pressed', 'false'); }); [customBtn, noneBtn].forEach(function (b) { if (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); } }); }

      function closeChart() {
        grid.setAttribute('hidden', ''); grid.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        self._releaseFocus();
      }
      function showChart() {
        // show as a body-level overlay so position:fixed escapes any transformed ancestor
        if (grid.parentNode !== document.body) { document.body.appendChild(grid); }
        grid.removeAttribute('hidden'); grid.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        self._trapFocus(grid);
        loadFonts();
      }
      function highlightCurrent(val, isUnchosen) {
        clearActive();
        var match = opts.filter(function (o) { return o.getAttribute('data-pp-font') === val; })[0];
        if (match) { match.classList.add('is-active'); match.setAttribute('aria-pressed', 'true'); }
        else if (customBtn && /^Custom/.test(val)) { customBtn.classList.add('is-active'); customBtn.setAttribute('aria-pressed', 'true'); }
        else if (noneBtn && isUnchosen) { noneBtn.classList.add('is-active'); noneBtn.setAttribute('aria-pressed', 'true'); }
      }
      function openChartFor(pick) {
        self._fontTarget = 'name';
        self._activeFontIdx = (parseInt(pick.getAttribute('data-index'), 10) || 1) - 1;
        var val = (valueInputOf(pick) || {}).value || '';
        highlightCurrent(val, val === grid.getAttribute('data-unchosen-value'));
        if (customInput) customInput.hidden = true;
        // sample text = this pendant's typed name (or the default word)
        var nameInput = self.fields && self.fields[self._activeFontIdx] && self.fields[self._activeFontIdx].querySelector('[data-pp-name]');
        var nm = (nameInput && nameInput.value && nameInput.value.trim()) || fontDefault;
        samples.forEach(function (s) { s.textContent = nm; });
        if (head) head.textContent = headBase + (self.fontPicks.length > 1 ? ' — ' + self.slotLabel(self._activeFontIdx) : '');   // which item this font is for (the typed name, e.g. "dog")
        showChart();
      }
      function openChartForEng(line, btn) {
        self._fontTarget = 'eng';
        self._engFontLine = line || '1';
        var cur = self.engFontObj(self._engSlot, self._engFontLine);
        highlightCurrent(cur ? cur.val : '', !cur);
        if (customInput) customInput.hidden = true;
        // sample text = the targeted line's typed text, else this item's name, else the default word
        var lineInp = self._engFontLine === '2' ? self.line2 : self.line1;
        var lt = lineInp && lineInp.value.trim();
        var pn = ((self.fields && self.fields[self._engSlot] && self.fields[self._engSlot].querySelector('[data-pp-name]')) || {}).value || '';
        var nm = lt || pn.trim() || fontDefault;
        samples.forEach(function (s) { s.textContent = nm; });
        var lbl = btn && btn.querySelector('.personalizer-fontpick__label');
        if (head) head.textContent = (lbl ? lbl.textContent : headBase) + ((self.activeCount || 1) > 1 ? ' — ' + self.slotLabel(self._engSlot) : '');
        showChart();
      }

      this.fontPicks.forEach(function (pick) {
        var openBtn = pick.querySelector('[data-pp-font-open]');
        if (openBtn) openBtn.addEventListener('click', function () { openChartFor(pick); });
      });
      engBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var row = btn.closest('[data-eng-fontpick]');
          openChartForEng(self.engFontPerLine ? ((row && row.dataset.line) || '1') : '1', btn);
        });
      });

      function choose(val, fam) {
        if (self._fontTarget === 'eng') {
          self.setEngFontObj(self._engSlot, self._engFontLine, { val: val, fam: fam });
          self.syncEngFontUI(self._engSlot);
          self.syncEngravingInputs();
          return;
        }
        var pick = pickEl(); if (!pick) return;
        var vi = valueInputOf(pick);
        if (vi) { vi.value = val; vi.name = 'properties[' + self.fontProp + ' ' + (self._activeFontIdx + 1) + ']'; }   // chosen -> visible property name
        var cur = pick.querySelector('[data-pp-font-current]'); if (cur) { cur.textContent = val; cur.classList.remove('pp-fp-placeholder'); }
        self.applyNameFont(fam, self._activeFontIdx);
      }
      opts.forEach(function (o) {
        o.addEventListener('click', function () {
          loadFonts();
          if (customInput) customInput.hidden = true;
          clearActive(); o.classList.add('is-active'); o.setAttribute('aria-pressed', 'true');
          choose(o.getAttribute('data-pp-font'), o.getAttribute('data-pp-font-fam'));
          closeChart();
        });
      });
      if (noneBtn) {
        // "No preference": revert this item to the not-chosen state (the merchant picks a matching font).
        noneBtn.addEventListener('click', function () {
          if (self._fontTarget === 'eng') {
            if (customInput) customInput.hidden = true;
            clearActive(); noneBtn.classList.add('is-active'); noneBtn.setAttribute('aria-pressed', 'true');
            self.setEngFontObj(self._engSlot, self._engFontLine, null);
            self.syncEngFontUI(self._engSlot);
            self.syncEngravingInputs();
            closeChart();
            return;
          }
          var pick = pickEl(); if (!pick) return;
          if (customInput) customInput.hidden = true;
          clearActive(); noneBtn.classList.add('is-active'); noneBtn.setAttribute('aria-pressed', 'true');
          var vi = valueInputOf(pick);
          if (vi) { vi.value = grid.getAttribute('data-unchosen-value') || ''; vi.name = ''; }   // unchosen -> nameless input -> nothing submitted
          var cur = pick.querySelector('[data-pp-font-current]'); if (cur) { cur.textContent = grid.getAttribute('data-unchosen-label') || ''; cur.classList.add('pp-fp-placeholder'); }
          if (opts[0]) self.applyNameFont(opts[0].getAttribute('data-pp-font-fam'), self._activeFontIdx);   // preview falls back to the default look
          closeChart();
        });
      }
      if (customBtn && customInput) {
        var customVal = function () { return customInput.value.trim() ? ('Custom: ' + customInput.value.trim()) : 'Custom (see notes)'; };
        customBtn.addEventListener('click', function () {
          clearActive(); customBtn.classList.add('is-active'); customBtn.setAttribute('aria-pressed', 'true');
          customInput.hidden = false; customInput.focus();
          choose(customVal(), 'inherit');
        });
        customInput.addEventListener('input', function () { choose(customVal(), 'inherit'); });
      }
      Array.prototype.forEach.call(grid.querySelectorAll('[data-pp-font-close]'), function (c) { c.addEventListener('click', closeChart); });
      self._bindDoc(document, 'keydown', function (e) { if ((e.key === 'Escape' || e.keyCode === 27) && !grid.hasAttribute('hidden')) closeChart(); });

      // Apply the default font (#1) to every tile + name preview so they start correct.
      // Only when the NAME picker is on — with just the engraving picker, names keep the merchant's font.
      if (opts[0] && this.fontPicks.length) this.applyNameFont(opts[0].getAttribute('data-pp-font-fam'));
    }

    applyNameFont(fam, idx) {
      var self = this;
      var setVar = function (el) { if (el) el.style.setProperty('--mn-font', fam); };
      var applyTile = function (t) { if (!t) return; setVar(t.querySelector('[data-pp-tile-name-box]') || t.querySelector('[data-pp-tile-name]')); };
      var applyPrev = function (i) { var f = self.fields && self.fields[i]; if (f) setVar(f.querySelector('[data-pp-name-preview]')); };
      if (typeof idx === 'number') { applyTile(this.tiles && this.tiles[idx]); applyPrev(idx); }
      else { (this.tiles || []).forEach(applyTile); (this.fields || []).forEach(function (f, i) { applyPrev(i); }); }
      this.refreshNameClearance();   // font height changed → re-check the gap
    }

    /* ---------- Crop & zoom ---------- */
    setupCropper() {
      if (!this.cropEnabled) return;
      this.cropper = this.querySelector('[data-pp-cropper]');
      if (!this.cropper) return;
      this.cropFrame = this.cropper.querySelector('[data-pp-crop-frame]');
      this.cropImg = this.cropper.querySelector('[data-pp-crop-img]');
      this.cropZoom = this.cropper.querySelector('[data-pp-crop-zoom]');
      var self = this, dragging = false, lx = 0, ly = 0;
      function pt(e) { var t = (e.touches && e.touches[0]) || e; return { x: t.clientX, y: t.clientY }; }
      function down(e) { if (!self._crop) return; dragging = true; var p = pt(e); lx = p.x; ly = p.y; e.preventDefault(); }
      function move(e) { if (!dragging || !self._crop) return; var p = pt(e); self._crop.left += (p.x - lx); self._crop.top += (p.y - ly); lx = p.x; ly = p.y; self.applyCrop(); e.preventDefault(); }
      function end() { dragging = false; }
      this.cropFrame.addEventListener('mousedown', down);
      this.cropFrame.addEventListener('touchstart', down, { passive: false });
      this._bindDoc(window, 'mousemove', move);
      this.cropFrame.addEventListener('touchmove', move, { passive: false });
      this._bindDoc(window, 'mouseup', end);
      this.cropFrame.addEventListener('touchend', end);
      this.cropFrame.addEventListener('wheel', function (e) {
        if (!self._crop) return;
        var z = Math.max(1, Math.min(3, self._crop.zoom * (e.deltaY < 0 ? 1.06 : 0.94)));
        if (self.cropZoom) self.cropZoom.value = z;
        self.onZoom(z); e.preventDefault();
      }, { passive: false });
      if (this.cropZoom) this.cropZoom.addEventListener('input', function () { self.onZoom(parseFloat(self.cropZoom.value) || 1); });
      var applyBtn = this.cropper.querySelector('[data-pp-crop-apply]');
      var cancelBtn = this.cropper.querySelector('[data-pp-crop-cancel]');
      if (applyBtn) applyBtn.addEventListener('click', function () { self.applyCropOutput(); });
      if (cancelBtn) cancelBtn.addEventListener('click', function () { self.cancelCrop(); });
      // Esc closes (cancels) the cropper; a tap on the dark backdrop (not the panel) cancels too.
      this._bindDoc(document, 'keydown', function (e) { if ((e.key === 'Escape' || e.keyCode === 27) && self.cropper && !self.cropper.hidden) self.cancelCrop(); });
      this.cropper.addEventListener('mousedown', function (e) { if (e.target === self.cropper) self.cancelCrop(); });
      // If the cropper is open when the phone rotates or the window resizes, re-fit the image to the new
      // frame (frame width tracks the viewport). Coalesced per frame; guarded so it no-ops when closed.
      var relayoutRaf = 0;
      var relayoutCrop = function () {
        if (relayoutRaf) return;
        relayoutRaf = (window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); })(function () {
          relayoutRaf = 0;
          if (self._crop && self.cropper && !self.cropper.hidden) self.layoutCrop();
        });
      };
      this._bindDoc(window, 'resize', relayoutCrop);
      this._bindDoc(window, 'orientationchange', relayoutCrop);
    }

    openCropper(file, wrap, field) {
      var self = this;
      if (!this.cropper || !this.cropImg) { if (this.cloudinary) this.uploadToCloudinary(file, wrap, field); else this.applyNativeFile(file, wrap, field); return; }
      var url = URL.createObjectURL(file);
      var im = new Image();
      im.onload = function () {
        if (self.minRes && Math.min(im.naturalWidth, im.naturalHeight) < self.minRes) self.showWarn(wrap, self.lowResMsg);
        var iz = self.cropInitialZoom || 1.2;
        self._crop = { file: file, wrap: wrap, field: field, iw: im.naturalWidth, ih: im.naturalHeight, zoom: iz, left: 0, top: 0, F: 0, s0: 1, url: url };
        self.cropImg.src = url;
        // Move to <body> like the mockup panel / fonts grid / gate: position:fixed must escape any ancestor
        // stacking context (sticky info column has z-index, pattern background adds isolation:isolate on the
        // section) or the overlay can render under the sticky header / later sections.
        if (self.cropper.parentNode !== document.body) { document.body.appendChild(self.cropper); self._movedCropper = self.cropper; }
        self.cropper.hidden = false;
        document.body.style.overflow = 'hidden';   // lock page scroll behind the overlay
        self._trapFocus(self.cropper);
        if (self.cropZoom) self.cropZoom.value = iz;
        requestAnimationFrame(function () { self.layoutCrop(); });
      };
      im.onerror = function () { try { URL.revokeObjectURL(url); } catch (e) {} if (self.cloudinary) self.uploadToCloudinary(file, wrap, field); else self.applyNativeFile(file, wrap, field); };
      im.src = url;
    }

    layoutCrop() {
      var c = this._crop; if (!c) return;
      c.F = this.cropFrame.clientWidth || 280;
      c.FH = this.cropFrame.clientHeight || c.F;
      c.s0 = Math.max(c.F / c.iw, c.FH / c.ih);
      var scale = c.s0 * c.zoom;
      c.left = (c.F - c.iw * scale) / 2;
      c.top = (c.FH - c.ih * scale) / 2;
      this.applyCrop();
    }

    applyCrop() {
      var c = this._crop; if (!c) return;
      var scale = c.s0 * c.zoom;
      var dispW = c.iw * scale, dispH = c.ih * scale;
      c.left = Math.min(0, Math.max(c.F - dispW, c.left));
      c.top = Math.min(0, Math.max((c.FH || c.F) - dispH, c.top));
      this.cropImg.style.width = dispW + 'px';
      this.cropImg.style.height = dispH + 'px';
      this.cropImg.style.left = c.left + 'px';
      this.cropImg.style.top = c.top + 'px';
    }

    onZoom(z) {
      var c = this._crop; if (!c) return;
      var oldScale = c.s0 * c.zoom;
      var fh = c.FH || c.F;
      var fx = (c.F / 2 - c.left) / oldScale, fy = (fh / 2 - c.top) / oldScale;
      c.zoom = Math.max(1, Math.min(3, z));
      var newScale = c.s0 * c.zoom;
      c.left = c.F / 2 - fx * newScale;
      c.top = fh / 2 - fy * newScale;
      this.applyCrop();
    }

    applyCropOutput() {
      var c = this._crop; if (!c) { this.closeCropper(); return; }
      var self = this, wrap = c.wrap, field = c.field, origFile = c.file;
      var scale = c.s0 * c.zoom;
      var fh = c.FH || c.F;
      var sx = Math.max(0, (0 - c.left) / scale), sy = Math.max(0, (0 - c.top) / scale);
      var sW = c.F / scale, sH = fh / scale;
      var ar = sW / sH, outW, outH;
      // Honour the merchant's "Max photo size" (pp_max_upload_px) — the crop path bypasses the
      // resize pipeline, so without this the cropped output ignored the configured cap (fixed 1400).
      var capPx = Math.min(1400, this.maxDim || 1400);
      if (ar >= 1) { outW = Math.min(capPx, Math.round(sW)); outH = Math.round(outW / ar); }
      else { outH = Math.min(capPx, Math.round(sH)); outW = Math.round(outH * ar); }
      if (outW < 1) outW = 600;
      if (outH < 1) outH = 600;
      try {
        var canvas = document.createElement('canvas');
        canvas.width = outW; canvas.height = outH;
        canvas.getContext('2d').drawImage(this.cropImg, sx, sy, sW, sH, 0, 0, outW, outH);
        canvas.toBlob(function (blob) { self.closeCropper(); self.afterCrop(blob ? self.namedFile(blob, origFile && origFile.name) : origFile, wrap, field); }, 'image/jpeg', 0.9);
      } catch (e) {
        this.closeCropper();
        this.afterCrop(origFile, wrap, field);
      }
    }

    afterCrop(payload, wrap, field) {
      var img = wrap.querySelector('[data-pp-preview-img]');
      var chip = wrap.querySelector('[data-pp-file-chip]');
      try {
        if (payload && payload.type && payload.type.indexOf('image') === 0) {
          var purl = URL.createObjectURL(payload);
          if (wrap._objUrl) { try { URL.revokeObjectURL(wrap._objUrl); } catch (e) {} }
          wrap._objUrl = purl;
          this.hide(chip); img.src = purl; this.show(img);
        }
      } catch (e) {}
      this.show(wrap.querySelector('[data-pp-preview]'));
      this.updateMockup();
      if (this.cloudinary) this.uploadToCloudinary(payload, wrap, field);
      else this.applyNativeFile(payload, wrap, field);
    }

    cancelCrop() {
      var c = this._crop;
      this.closeCropper();
      if (c) {
        var input = c.wrap.querySelector('[data-pp-file]');
        if (input) input.value = '';
        this.resetUpload(c.wrap, c.field);
      }
    }

    closeCropper() {
      if (this._crop && this._crop.url) { try { URL.revokeObjectURL(this._crop.url); } catch (e) {} }
      this._crop = null;
      if (this.cropper) this.cropper.hidden = true;
      document.body.style.overflow = '';
      this._releaseFocus();
    }

    // Shopify-file mode (and the Cloudinary-failure fallback): write the PROCESSED file (cropped/
    // resized) back into the native input via DataTransfer, so the form submits exactly what the
    // customer approved — previously the original untouched file was submitted and the crop was lost.
    // Returns false when the file is over the size cap or DataTransfer is unsupported (old Safari:
    // the original file stays in the input — the previous behaviour).
    applyNativeFile(file, wrap, field) {
      var input = field && field.querySelector('[data-pp-file]');
      if (!input || !file) return false;
      if (!fmtBytesOk(file, this.maxMb)) {
        var errEl = wrap.querySelector('[data-pp-file-error]');
        this.resetUpload(wrap, field);
        if (errEl) { errEl.textContent = 'File is too large (max ' + this.maxMb + 'MB).'; this.show(errEl); }
        return false;
      }
      try {
        if (!(input.files && input.files[0] === file)) {
          var f = (typeof File === 'function' && file instanceof File) ? file : new File([file], 'photo.jpg', { type: file.type || 'image/jpeg' });
          var dt = new DataTransfer();
          dt.items.add(f);
          input.files = dt.files;
        }
      } catch (e) { return false; }
      wrap.classList.remove('is-uploading');
      wrap.classList.add('is-uploaded');
      return true;
    }

    uploadToCloudinary(file, wrap, field) {
      var self = this;
      var urlInput = field && field.querySelector('[data-pp-photo-url]');
      var progress = wrap.querySelector('[data-pp-progress]');
      var bar = wrap.querySelector('[data-pp-progress-bar]');
      var errEl = wrap.querySelector('[data-pp-file-error]');
      var statusEl = wrap.querySelector('[data-pp-status]');
      var pctEl = wrap.querySelector('[data-pp-status-pct]');
      var labelEl = wrap.querySelector('[data-pp-status-label]');
      var ringEl = wrap.querySelector('[data-pp-ring]');
      var ringBar = wrap.querySelector('[data-pp-progress-ring]');
      var MAX_ATTEMPTS = 3;
      var TIMEOUT_MS = 45000;

      // Cancel any previous in-flight upload for this field (re-selection) without leaking the counter.
      this.abortUpload(wrap);
      // Session token: a pending retry timer from a superseded/aborted upload must not fire (it would
      // run a 2nd concurrent upload and desync the Add-to-cart lock).
      var session = (this._uploadSeq = (this._uploadSeq || 0) + 1);
      wrap._ppSession = session;
      wrap._ppFailed = false;
      // A previous Cloudinary failure may have switched this field to native-fallback mode — undo it
      // for the fresh attempt so the property is never submitted twice (file + URL).
      var fbInput = field && field.querySelector('[data-pp-file]');
      if (fbInput && wrap._ppNativeFallback) {
        if (fbInput._ppOrigName) fbInput.name = fbInput._ppOrigName; else fbInput.removeAttribute('name');
        if (fbInput._ppOrigForm) fbInput.setAttribute('form', fbInput._ppOrigForm); else fbInput.removeAttribute('form');
        wrap._ppNativeFallback = false;
      }
      this.hideRetry(wrap);
      this.hide(errEl);
      if (urlInput) { urlInput.value = ''; urlInput.disabled = true; }
      wrap.classList.add('is-uploading');
      wrap.classList.remove('is-uploaded');
      this.uploading++;
      this.updateBusyState();
      this.show(progress);
      this.show(ringEl);
      if (bar) bar.style.transform = 'translateX(-100%)';
      if (ringBar) ringBar.style.strokeDashoffset = 100;
      if (statusEl) {
        if (labelEl) labelEl.textContent = statusEl.dataset.uploading || 'Uploading…';
        this.show(statusEl);
      }
      if (pctEl) { pctEl.textContent = '0%'; pctEl.hidden = false; }

      var attempt = 0;

      function done() {
        wrap._ppXhr = null;
        wrap.classList.remove('is-uploading');
        self.uploading = Math.max(0, self.uploading - 1);
        self.hide(progress);
        self.hide(ringEl);
        self.updateBusyState();
      }
      function succeed(res) {
        done();
        var url = res.secure_url;
        var fmt = (res.format || '').toLowerCase();
        // HEIC/HEIF can't be viewed in desktop browsers or the Shopify admin order page. Store a
        // JPG-delivery URL so the photo is viewable EVERYWHERE the property shows (cart, order page,
        // confirmation email, and the admin order detail where you fulfill). The original HEIC stays
        // on Cloudinary at full quality — only the delivered URL is converted.
        if (fmt === 'heic' || fmt === 'heif') {
          var jpgBase = url.replace(/\.(heic|heif)$/i, '.jpg');
          url = jpgBase.replace('/upload/', '/upload/f_jpg/');
          // HEIC has no on-screen preview (browsers can't decode it) — now show the customer their photo.
          var img = wrap.querySelector('[data-pp-preview-img]');
          var chip = wrap.querySelector('[data-pp-file-chip]');
          if (img) { img.src = jpgBase.replace('/upload/', '/upload/f_jpg,w_400/'); self.hide(chip); self.show(img); }
        }
        if (urlInput) { urlInput.value = url; urlInput.disabled = !!(field && field.hidden); }
        wrap.classList.add('is-uploaded');
        wrap._ppFailed = false;
        if (statusEl) statusEl.hidden = true;
        if (isHeic(file) && self.minRes && res.width && res.height && Math.min(res.width, res.height) < self.minRes) self.showWarn(wrap, self.lowResMsg);
        self.updateMockup();
        // Warm the AI background-removal transform now so it's ready by the time the customer opens the preview.
        if (self.mockupRemoveBg && url) { var warmImg = new Image(); warmImg.src = self.effectSrc('', url); }
      }
      function fail(msg) {
        done();
        // Cloudinary is down or rejecting -> last resort: attach the processed file to the native
        // input (Shopify-file behaviour) so the sale is not lost — the photo uploads to Shopify
        // with the form POST as the same "Photo i" property, instead of blocking add-to-cart.
        if (self.cloudFallback && urlInput && self.applyNativeFile(file, wrap, field)) {
          var nInp = field && field.querySelector('[data-pp-file]');
          if (nInp) {
            if (nInp._ppOrigName === undefined) { nInp._ppOrigName = nInp.getAttribute('name') || ''; nInp._ppOrigForm = nInp.getAttribute('form') || ''; }
            nInp.name = urlInput.name;
            nInp.setAttribute('form', urlInput.getAttribute('form') || '');
            wrap._ppNativeFallback = true;
            urlInput.value = ''; urlInput.disabled = true;
            wrap._ppFailed = false;
            if (statusEl) statusEl.hidden = true;
            self.hide(errEl);
            self.hideRetry(wrap);
            self.showWarn(wrap, self.fallbackMsg || 'Photo attached — it will upload with your order.');
            return;
          }
        }
        wrap._ppFailed = true;
        if (statusEl) statusEl.hidden = true;
        if (errEl) { errEl.textContent = msg; self.show(errEl); }
        self.showRetry(wrap, field, file);
      }
      function retry() {
        if (bar) bar.style.transform = 'translateX(-100%)';
        var delay = 700 * attempt;
        setTimeout(function () { if (wrap._ppSession === session && wrap.classList.contains('is-uploading')) send(); }, delay);
      }

      function send() {
        attempt++;
        var fd = new FormData();
        fd.append('file', file);
        fd.append('upload_preset', self.cloudPreset);
        if (self.cloudFolder) fd.append('folder', self.cloudFolder);

        var xhr = new XMLHttpRequest();
        wrap._ppXhr = xhr;
        xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + self.cloudName + '/auto/upload');
        xhr.timeout = TIMEOUT_MS;
        xhr.upload.onprogress = function (e) {
          if (!e.lengthComputable) return;
          var pct = Math.round((e.loaded / e.total) * 100);
          if (bar) bar.style.transform = 'translateX(' + (pct - 100) + '%)';
          if (ringBar) ringBar.style.strokeDashoffset = (100 - pct);
          if (pctEl) pctEl.textContent = pct + '%';
        };
        xhr.onload = function () {
          var ok = xhr.status >= 200 && xhr.status < 300;
          var res = null;
          try { res = JSON.parse(xhr.responseText); } catch (e) {}
          if (ok && res && res.secure_url) { succeed(res); return; }
          // Retry only transient failures (network drop / throttling / server errors); fail fast on real rejections.
          var transient = xhr.status === 0 || xhr.status === 408 || xhr.status === 429 || xhr.status === 420 || xhr.status >= 500;
          if (transient && attempt < MAX_ATTEMPTS) { retry(); return; }
          var msg = (res && res.error && res.error.message) || ('Upload failed (' + xhr.status + '). Please try again.');
          fail(msg);
        };
        xhr.onerror = function () {
          if (attempt < MAX_ATTEMPTS) { retry(); return; }
          fail('Network error during upload. Please check your connection and tap Retry.');
        };
        xhr.ontimeout = function () {
          if (attempt < MAX_ATTEMPTS) { retry(); return; }
          fail('Upload timed out. Please check your connection and tap Retry.');
        };
        xhr.send(fd);
      }

      send();
    }

    abortUpload(wrap) {
      wrap._ppSession = 0;   // invalidate any pending retry timer for this field
      if (wrap._ppXhr) { try { wrap._ppXhr.abort(); } catch (e) {} wrap._ppXhr = null; }
      if (wrap.classList.contains('is-uploading')) {
        wrap.classList.remove('is-uploading');
        this.uploading = Math.max(0, this.uploading - 1);
        this.updateBusyState();
      }
    }

    // Lock the Add to cart button while any photo is still uploading, so customers
    // can't submit a half-uploaded order (and never see the "still uploading" error).
    updateBusyState() {
      var busy = this.uploading > 0;
      if (busy) this.classList.add('pp-is-uploading'); else this.classList.remove('pp-is-uploading');
      var btn = this.form && this.form.querySelector('[name="add"]');
      if (!btn) return;
      if (busy) {
        if (!btn.disabled) { btn.disabled = true; btn.dataset.ppLocked = '1'; }
        btn.setAttribute('aria-busy', 'true');
      } else {
        if (btn.dataset.ppLocked) { btn.disabled = false; delete btn.dataset.ppLocked; }
        btn.removeAttribute('aria-busy');
      }
    }

    showRetry(wrap, field, file) {
      var self = this;
      var btn = wrap.querySelector('[data-pp-retry]');
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('data-pp-retry', '');
        btn.className = 'personalizer-upload__retry';
        btn.textContent = 'Retry upload';
        var errSlot = wrap.querySelector('[data-pp-file-error]');
        if (errSlot && errSlot.parentNode) errSlot.parentNode.insertBefore(btn, errSlot.nextSibling);
        else wrap.appendChild(btn);
        btn.addEventListener('click', function () {
          btn.hidden = true;
          self.hide(wrap.querySelector('[data-pp-file-error]'));
          self.uploadToCloudinary(btn._ppFile, wrap, btn._ppField);
        });
      }
      btn._ppFile = file;
      btn._ppField = field;
      btn.hidden = false;
    }

    hideRetry(wrap) {
      var btn = wrap.querySelector('[data-pp-retry]');
      if (btn) btn.hidden = true;
    }

    /* ---------- Engraving modal ---------- */
    setupEngraving() {
      if (!this.engravingEnabled) return;
      var self = this;
      this.engravingWrap = this.querySelector('[data-pp-engraving]');
      this.engPropsWrap = this.querySelector('[data-engraving-props]');
      this.titleEl = this.querySelector('[data-engraving-title]');
      this.subEl = this.querySelector('[data-engraving-sub]');
      this.modal = document.getElementById('PersonalizerEngravingModal-' + this.blockId);
      this.chooser = document.getElementById('PersonalizerEngravingChooser-' + this.blockId);
      if (!this.modal) return;

      this.line1 = this.modal.querySelector('[data-engraving-line="1"]');
      this.line2 = this.modal.querySelector('[data-engraving-line="2"]');
      this.previewLine1 = this.modal.querySelector('[data-engraving-preview-line="1"]');
      this.previewLine2 = this.modal.querySelector('[data-engraving-preview-line="2"]');

      [this.line1, this.line2].forEach(function (inp) {
        if (!inp) return;
        var counter = self.modal.querySelector('[data-engraving-line-counter="' + inp.getAttribute('data-engraving-line') + '"]');
        var max = inp.getAttribute('maxlength');
        var update = function () {
          if (counter) counter.textContent = inp.value.length + '/' + max;
          self.updatePreview();
        };
        inp.addEventListener('input', update);
        update();
      });

      var saveBtn = this.modal.querySelector('[data-engraving-save]');
      if (saveBtn) saveBtn.addEventListener('click', function () { self.saveEngraving(); });
      this.engRemoveBtn = this.modal.querySelector('[data-engraving-remove]');
      if (this.engRemoveBtn) this.engRemoveBtn.addEventListener('click', function () { self.removeEngraving(); });

      // Route the card click ourselves (capture beats the theme's modal-opener): with one item open the
      // text popup directly; with 2+ open the pendant chooser so EACH item gets its own message.
      var card = this.engravingWrap && this.engravingWrap.querySelector('[data-engraving-card]');
      if (card) card.addEventListener('click', function (e) {
        e.preventDefault(); e.stopImmediatePropagation();
        if ((self.activeCount || 1) > 1 && self.chooser) self.openEngravingChooser();
        else self.openEngravingFor(0);
      }, true);
      if (this.chooser) {
        var x = this.chooser.querySelector('[data-eng-chooser-close]');
        if (x) x.addEventListener('click', function () { if (typeof self.chooser.hide === 'function') self.chooser.hide(); });
      }
      this._modalTitleBase = (this.modal.querySelector('.personalizer-engraving-modal__title') || {}).textContent || '';
    }

    engravedCount() {
      var n = 0;
      for (var i = 0; i < (this.activeCount || 1); i++) if (this.engravings[i]) n++;
      return n;
    }

    // Engraved slots among the units actually being bought RIGHT NOW. activeCount can lag the
    // variant picker for a sub-second after a count change — charging by it can over/under-bill;
    // at add time always count against the live selection instead.
    engravedCountFor(slots) {
      var n = 0;
      for (var i = 0; i < slots; i++) if (this.engravings[i]) n++;
      return n;
    }

    slotLabel(i) {
      var f = this.fields && this.fields[i];
      var inp = f && f.querySelector('[data-pp-name]');
      var v = inp && inp.value.trim();
      if (v) return v;
      var lbl = (this.chooser && this.chooser.dataset.itemLabel) || (this.fontsEl && this.fontsEl.dataset.itemLabel) || 'Item';
      return lbl + ' ' + (i + 1);
    }

    openEngravingFor(i) {
      this._engSlot = i;
      var saved = (this.engravings[i] || '').split(' || ');
      if (this.line1) { this.line1.value = saved[0] || ''; this.line1.dispatchEvent(new Event('input', { bubbles: true })); }
      if (this.line2) { this.line2.value = saved[1] || ''; this.line2.dispatchEvent(new Event('input', { bubbles: true })); }
      this.syncEngFontUI(i);   // trigger text + preview font follow this slot's saved choice
      if (this.engRemoveBtn) this.engRemoveBtn.hidden = !this.engravings[i];   // only offer removal when something is saved
      var t = this.modal.querySelector('.personalizer-engraving-modal__title');
      if (t) t.textContent = (this.activeCount || 1) > 1 ? this._modalTitleBase + ' — ' + this.slotLabel(i) : this._modalTitleBase;
      if (this.chooser && typeof this.chooser.hide === 'function' && this.chooser.hasAttribute('open')) this.chooser.hide();
      if (typeof this.modal.show === 'function') this.modal.show();
      else this.modal.setAttribute('open', '');
    }

    openEngravingChooser() {
      var self = this;
      var list = this.chooser.querySelector('[data-eng-choose-list]');
      if (!list) return;
      var tpl = this.chooser.dataset.btnTpl || 'Add engraving on back of [name]';
      var price = this.chooser.dataset.engPrice || '';
      list.innerHTML = '';
      for (var i = 0; i < (this.activeCount || 1); i++) {
        (function (i) {
          var saved = self.engravings[i];
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'personalizer-engraving-chooser__opt' + (saved ? ' is-engraved' : '');
          var label = tpl.replace(/\[name\]/g, self.slotLabel(i));
          b.innerHTML = (saved ? '<span class="personalizer-engraving-chooser__badge" aria-hidden="true"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>' : '') +
            '<span class="personalizer-engraving-chooser__opt-title"></span>' +
            (saved ? '<span class="personalizer-engraving-chooser__opt-saved"></span>'
                   : (price ? '<span class="personalizer-engraving-chooser__opt-price">+' + price + '</span>' : ''));
          b.querySelector('.personalizer-engraving-chooser__opt-title').textContent = label;
          if (saved) { var sv = b.querySelector('.personalizer-engraving-chooser__opt-saved'); sv.textContent = saved.split(' || ').join(' / '); }
          b.addEventListener('click', function () { self.openEngravingFor(i); });
          list.appendChild(b);
        })(i);
      }
      if (typeof this.chooser.show === 'function') this.chooser.show();
      else this.chooser.setAttribute('open', '');
    }

    engFontObj(slot, line) {
      var m = this.engFonts[slot];
      return (m && m[line]) || null;
    }
    setEngFontObj(slot, line, obj) {
      var m = this.engFonts[slot] || (this.engFonts[slot] = {});
      if (obj) m[line] = obj; else delete m[line];
    }
    /* Did the customer actually pick ANY engraving font for this slot's text lines? */
    engFontChosen(slot) {
      if (this.engFontObj(slot, '1')) return true;
      if (!this.engFontPerLine) return false;
      var parts = String(this.engravings[slot] || '').split(' || ').length;
      return parts > 1 && !!this.engFontObj(slot, '2');
    }
    /* The order-property value for one slot: fonts paired 1:1 with the engraving's text lines
       ("font1 || font2" for a 2-line message); single-font mode emits one value. */
    engFontValueFor(slot) {
      var unchosen = (this.fontsEl && this.fontsEl.dataset.unchosenValue) || 'Not selected (we pick)';
      var f1 = this.engFontObj(slot, '1');
      var v1 = (f1 && f1.val) || unchosen;
      if (!this.engFontPerLine) return v1;
      var parts = String(this.engravings[slot] || '').split(' || ').length;
      if (parts < 2) return v1;
      var f2 = this.engFontObj(slot, '2');
      return v1 + ' || ' + ((f2 && f2.val) || unchosen);
    }

    /* Reflect slot i's engraving fonts on the modal's font row(s) + live preview lines. */
    syncEngFontUI(i) {
      if (!this.engFontProp || !this.modal) return;
      var self = this;
      var rows = this.modal.querySelectorAll('[data-eng-fontpick]');
      Array.prototype.forEach.call(rows, function (row) {
        var line = self.engFontPerLine ? (row.dataset.line || '1') : '1';
        var cur = row.querySelector('[data-eng-font-current]');
        if (!cur) return;
        var f = self.engFontObj(i, line);
        if (f) { cur.textContent = f.val; cur.classList.remove('pp-fp-placeholder'); }
        else { cur.textContent = (self.fontsEl && self.fontsEl.dataset.unchosenLabel) || ''; cur.classList.add('pp-fp-placeholder'); }
      });
      // Live preview: each line renders in its own font; no pick -> the merchant's preview font.
      var f1 = this.engFontObj(i, '1');
      var f2 = this.engFontPerLine ? this.engFontObj(i, '2') : f1;
      var fam = function (f) { return (f && f.fam && f.fam !== 'inherit') ? f.fam : ''; };
      if (this.previewLine1) this.previewLine1.style.fontFamily = fam(f1);
      if (this.previewLine2) this.previewLine2.style.fontFamily = fam(f2);
      if ((f1 || f2) && this._loadChartFonts) this._loadChartFonts();   // the families must actually be fetched to render
    }

    saveEngraving() {
      var l1 = (this.line1 && this.line1.value.trim()) || '';
      var l2 = (this.line2 && this.line2.value.trim()) || '';
      var text = [l1, l2].filter(Boolean).join(' || ');
      // Text lines compact upward on save (a lone line 2 becomes line 1) — shift its font with it.
      if (this.engFontPerLine && !l1 && l2) { this.setEngFontObj(this._engSlot, '1', this.engFontObj(this._engSlot, '2')); this.setEngFontObj(this._engSlot, '2', null); }
      if (text) this.engravings[this._engSlot] = text;
      else { delete this.engravings[this._engSlot]; delete this.engFonts[this._engSlot]; }
      this.syncEngravingInputs();
      this.updateEngravingLabel();
      if (this.modal && typeof this.modal.hide === 'function') this.modal.hide();
      // With several items, return to the chooser so the customer can engrave the next one.
      if ((this.activeCount || 1) > 1 && this.chooser) this.openEngravingChooser();
    }

    /* Explicit opt-out: wipe this item's engraving (text AND fonts), stop charging it, return to the chooser. */
    removeEngraving() {
      delete this.engravings[this._engSlot];
      delete this.engFonts[this._engSlot];
      if (this.line1) { this.line1.value = ''; this.line1.dispatchEvent(new Event('input', { bubbles: true })); }
      if (this.line2) { this.line2.value = ''; this.line2.dispatchEvent(new Event('input', { bubbles: true })); }
      this.syncEngFontUI(this._engSlot);
      this.syncEngravingInputs();
      this.updateEngravingLabel();
      if (this.modal && typeof this.modal.hide === 'function') this.modal.hide();
      if ((this.activeCount || 1) > 1 && this.chooser) this.openEngravingChooser();
    }

    /* One hidden form-associated input per engraved item: properties[Engraving N]. */
    syncEngravingInputs() {
      this.engravingActive = this.engravedCount() > 0;
      if (this.engravingWrap) this.engravingWrap.classList.toggle('is-active', this.engravingActive);
      if (!this.engPropsWrap) return;
      var formId = this.engPropsWrap.dataset.formId || (this.form && this.form.id) || '';
      this.engPropsWrap.innerHTML = '';
      for (var i = 0; i < (this.activeCount || 1); i++) {
        if (!this.engravings[i]) continue;
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[' + this.engProp + ' ' + (i + 1) + ']';
        inp.value = this.engravings[i];
        if (formId) inp.setAttribute('form', formId);
        this.engPropsWrap.appendChild(inp);
        if (this.engFontProp && this.engFontChosen(i)) {
          // Font rides along only when the customer actually picked one; skipped -> no property (merchant picks).
          var fin = document.createElement('input');
          fin.type = 'hidden';
          fin.name = 'properties[' + this.engFontProp + ' ' + (i + 1) + ']';
          fin.value = this.engFontValueFor(i);
          if (formId) fin.setAttribute('form', formId);
          this.engPropsWrap.appendChild(fin);
        }
      }
    }

    updatePreview() {
      if (this.previewLine1) this.previewLine1.textContent = (this.line1 && this.line1.value) || '';
      if (this.previewLine2) this.previewLine2.textContent = (this.line2 && this.line2.value) || '';
    }

    updateEngravingLabel() {
      if (!this.engravingEnabled || !this.titleEl) return;
      var n = this.activeCount || 1;
      var t = this.cardTitleTpl.replace(/\[count\]/g, n).replace(/\[s\]/g, n > 1 ? 's' : '');
      this.titleEl.textContent = t;
      if (this.subEl) this.subEl.textContent = this.cardSubTpl.replace(/\[count\]/g, n).replace(/\[s\]/g, n > 1 ? 's' : '');
      this.syncEngravingInputs();   // item count changed -> drop engravings of slots that are no longer active
    }

    /* ---------- Add to cart ---------- */
    bindSubmit() {
      // Capture phase on document so we run before the theme's product-form handler.
      this._bindDoc(document, 'submit', this.onSubmit.bind(this), true);
    }

    /* ---------- Photo-required popup (gate) ---------- */
    setupGate() {
      this.gateEl = this.querySelector('[data-pp-gate]');
      if (!this.gateEl) return;
      var self = this, i;
      var closers = this.gateEl.querySelectorAll('[data-pp-gate-close]');
      for (i = 0; i < closers.length; i++) this._bindDoc(closers[i], 'click', function () { self.closePhotoGate(); });
      this._bindDoc(this.gateEl, 'click', function (e) { if (e.target === self.gateEl) self.closePhotoGate(); });   // click the dark backdrop to close
      var up = this.gateEl.querySelector('[data-pp-gate-upload]');
      if (up) this._bindDoc(up, 'click', function () { self.closePhotoGate(); self.jumpToUpload(); });
      this._bindDoc(document, 'keydown', function (e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && self.gateEl && !self.gateEl.hasAttribute('hidden')) self.closePhotoGate();
      });
      // Buy it now / skip-cart / sticky ATC: these call the main product-form's handleSubmit() straight
      // from a click listener (no submit event fires), so guard them with a capture-phase click that runs
      // before the theme's listener (stopImmediatePropagation on document-capture cancels it entirely).
      this._bindDoc(document, 'click', function (e) {
        var t = e.target;
        if (!t || !t.closest || !self.form) return;
        var pay = t.closest('.shopify-payment-button__button, .shopify-payment-button [role="button"], [data-skip-cart-button], [id^="SectionAtcBtn-"]');
        if (!pay) return;
        var isSkip = (pay.hasAttribute && pay.hasAttribute('data-skip-cart-button')) || (pay.id && pay.id.indexOf('SectionAtcBtn-') === 0);
        // Skip-cart buttons (incl. the sticky ATC, which sits OUTSIDE the form) always drive the MAIN
        // product form — that's ours when our form's wrapper is data-main. Payment buttons must be inside our form.
        var ours;
        if (isSkip) { var pf = self.form.closest('product-form'); ours = self.form.contains(pay) || !!(pf && pf.dataset && pf.dataset.main === 'true'); }
        else ours = self.form.contains(pay);
        if (!ours) return;
        if (!self.validate()) {
          e.preventDefault(); e.stopImmediatePropagation();
          if (self._missingPhoto && self.gateEl) self.openPhotoGate();
          else self.flashError(self._validateMsg || 'Please complete the required fields before adding to cart.');
          return;
        }
        // Valid — but skip-cart/sticky buttons call handleSubmit() directly (no submit event), which
        // would bypass addPerUnit/addWithEngraving: no per-unit split and NO engraving fee line.
        // Take over with our own add flow. Payment-wallet buttons are left alone (they run Shopify's
        // own checkout SDK) — keep dynamic checkout disabled on personalized products.
        if (isSkip && (self.canSplit() || (self.engravingActive && self.engravingVariant && !self.hasNativeFallback()))) {
          e.preventDefault(); e.stopImmediatePropagation();
          if (self._addBusy) return;   // double-click while an add is in flight
          self._extBtn = pay;          // mirror the loading spinner on the button that was clicked
          var goCheckout = !!(pay.hasAttribute && pay.hasAttribute('data-skip-cart-button'));
          if (self.canSplit()) self.addPerUnit(goCheckout);
          else self.addWithEngraving(goCheckout);
        }
      }, true);
    }
    openPhotoGate() {
      if (!this.gateEl) return;
      if (this.gateEl.parentNode !== document.body) { document.body.appendChild(this.gateEl); this._movedGate = this.gateEl; }   // escape any transformed ancestor
      this.gateEl.removeAttribute('hidden'); this.gateEl.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this._trapFocus(this.gateEl);
      var btn = this.gateEl.querySelector('[data-pp-gate-upload]'); if (btn) btn.focus();
    }
    closePhotoGate() {
      if (!this.gateEl) return;
      this.gateEl.setAttribute('hidden', ''); this.gateEl.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      this._releaseFocus();
    }
    jumpToUpload() {
      for (var i = 0; i < this.activeCount; i++) {
        var f = this.fields[i]; if (!f) continue;
        var has = false;
        if (this.cloudinary) { var u = f.querySelector('[data-pp-photo-url]'); has = !!(u && u.value); }
        else { var fl = f.querySelector('[data-pp-file]'); has = !!(fl && fl.files && fl.files.length); }
        if (!has) {
          var dz = f.querySelector('.personalizer-upload__dropzone') || f;
          if (dz.scrollIntoView) dz.scrollIntoView({ behavior: 'smooth', block: 'center' });
          // Take the customer TO the upload box and highlight it — let them tap it themselves (don't open the file dialog).
          var wrap = f.querySelector('.personalizer-upload') || dz;
          wrap.classList.remove('pp-upload-flash'); void wrap.offsetWidth; wrap.classList.add('pp-upload-flash');
          var w = wrap; setTimeout(function () { w.classList.remove('pp-upload-flash'); }, 1800);
          if (dz.focus) { try { dz.focus({ preventScroll: true }); } catch (err) { try { dz.focus(); } catch (e2) {} } }
          return;
        }
      }
    }

    validate() {
      this._validateMsg = null;
      this._missingPhoto = false;
      // Never submit while a background upload is still running (would lose the photo).
      if (this.uploading > 0) {
        this._validateMsg = 'Your photo is still uploading — please wait a moment and try again.';
        return false;
      }
      // A photo whose upload FAILED has an empty URL; block with a clear message even if photos aren't
      // strictly required, so no order goes through with a broken/missing photo.
      for (var k = 0; k < this.activeCount; k++) {
        var fk = this.fields[k]; if (!fk) continue;
        var wrapK = fk.querySelector('.personalizer-upload');
        if (wrapK && wrapK._ppFailed) {
          this._validateMsg = 'A photo failed to upload — tap Retry on it, then add to cart.';
          return false;
        }
      }
      // Bundle tier asks for more units than the block can hold -> units past the cap would have no
      // photo. Block instead of silently adding a photo-less order (only fires on a misconfigured store).
      if (this.unitCountOption && this.totalUnitCount() > this.maxItems) {
        this._validateMsg = 'This quantity needs more photos than are available here — please choose a smaller quantity.';
        return false;
      }
      if (!this.photoRequired && !this.nameRequired) return true;
      for (var i = 0; i < this.activeCount; i++) {
        var f = this.fields[i];
        if (!f) continue;
        if (this.nameRequired) {
          var name = f.querySelector('[data-pp-name]');
          if (name && !name.value.trim()) return false;
        }
        if (this.photoRequired) {
          if (this.cloudinary) {
            var u = f.querySelector('[data-pp-photo-url]');
            // Native-fallback photo (Cloudinary was down): the file rides the form POST instead of the URL.
            var wnf = f.querySelector('.personalizer-upload');
            var nfi = f.querySelector('[data-pp-file]');
            var nativeOk = wnf && wnf._ppNativeFallback && nfi && nfi.files && nfi.files.length > 0;
            if (u && !u.value && !nativeOk) { this._missingPhoto = true; return false; }
          } else {
            var file = f.querySelector('[data-pp-file]');
            if (file && (!file.files || !file.files.length)) { this._missingPhoto = true; return false; }
          }
        }
      }
      return true;
    }

    onSubmit(e) {
      if (!this.form || e.target !== this.form) return;

      // An add is already in flight (double-click / double Enter): swallow the repeat submit
      // entirely, otherwise addPerUnit/addWithEngraving run twice and the cart doubles up.
      if (this._addBusy) { e.preventDefault(); e.stopImmediatePropagation(); return; }

      if (!this.validate()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (this._missingPhoto && this.gateEl) this.openPhotoGate();
        else this.flashError(this._validateMsg || 'Please complete the required fields before adding to cart.');
        return;
      }

      // Per-unit split: when each unit has its own variant (per-unit count option) and photos
      // are Cloudinary URLs, add ONE line item per unit (its variant + its slots' photos,
      // renumbered from 1) so the cart shows separate units instead of one merged line.
      if (this.canSplit()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.addPerUnit();
        return;
      }

      // No extra engraving line item needed -> let the theme add the main product
      // (its FormData already includes our form-associated photo/name/engraving props).
      if (!this.engravingActive || !this.engravingVariant) return;

      // A native-fallback photo can only travel with the form POST (the JSON takeover can't carry
      // files) -> let the native submit run; the engraving text still rides the form, only the fee
      // line item is skipped for this rare Cloudinary-outage order.
      if (this.hasNativeFallback()) return;

      // Engraving selected: take over to add the main product AND the engraving line item.
      e.preventDefault();
      e.stopImmediatePropagation();
      this.addWithEngraving();
    }

    canSplit() {
      // Native-fallback photos can only travel with the form POST — the JSON per-unit add
      // carries URL strings and would silently drop them.
      return !!(this.cloudinary && !this.hasNativeFallback() && this.unitCountOption && this.variantData &&
        this.variantData.variants && this.variantData.variants.length);
    }

    hasNativeFallback() {
      for (var i = 0; i < this.activeCount; i++) {
        var f = this.fields[i]; if (!f) continue;
        var w = f.querySelector('.personalizer-upload');
        if (w && w._ppNativeFallback) return true;
      }
      return false;
    }

    lookupVariant(optsByName) {
      var names = (this.variantData && this.variantData.options) || [];
      var want = names.map(function (n) { var x = optsByName[n]; return String(x == null ? '' : x); });
      var vs = this.variantData.variants;
      for (var i = 0; i < vs.length; i++) {
        var o = vs[i].o || [];
        var ok = true;
        for (var j = 0; j < want.length; j++) { if (String(o[j]) !== want[j]) { ok = false; break; } }
        if (ok) return vs[i].id;
      }
      return 0;
    }

    readUnits() {
      var self = this;
      var checked = document.querySelector('input[name="quantity"]:checked');
      var label = checked ? checked.nextElementSibling : null;
      var items = label && label.querySelectorAll ? label.querySelectorAll('.quantity-break__selector-item') : [];
      var out = [];
      if (items.length) {
        Array.prototype.forEach.call(items, function (it) {
          var optsByName = {};
          Array.prototype.forEach.call(it.querySelectorAll('select[name^="options["]'), function (s) {
            optsByName[s.name.slice(8, -1)] = s.value;
          });
          var count = parseInt(optsByName[self.unitCountOption], 10) || 1;
          out.push({ count: count, variantId: self.lookupVariant(optsByName) });
        });
      } else {
        // Single product (no Bundle & Save) -> one unit = the selected variant. The per-unit count
        // comes from that variant (works for dropdown / pills / swatches / "Quantity breaks" cards).
        var hid = self.form.querySelector('[name="id"]');
        var vid = hid ? parseInt(hid.value, 10) : 0;
        var count = self.selectedVariantUnitCount() || self.unitCountInputValue() || self.activeCount || 1;
        out.push({ count: count, variantId: vid });
      }
      return out;
    }

    readPhotos() {
      var out = [];
      for (var i = 0; i < this.activeCount; i++) {
        var f = this.fields[i];
        if (!f) { out.push({ url: '', name: '' }); continue; }
        var u = f.querySelector('[data-pp-photo-url]');
        var nm = f.querySelector('[data-pp-name]');
        out.push({ url: u ? u.value : '', name: nm ? nm.value : '' });
      }
      return out;
    }

    async addPerUnit(goCheckout) {
      this._addBusy = true;
      this.setLoading(true);
      var self = this;
      var sectionId = this.cartSectionId();
      try {
        var units = this.readUnits();
        var photos = this.readPhotos();
        var items = [];
        var idx = 0;
        var total = 0;
        units.forEach(function (unit) {
          total += unit.count;
          // A unit that can't resolve means this page's option data no longer matches the
          // product's variants (deleted/renamed). Adding the rest anyway would silently ship a
          // partial, mis-charged order — fail the whole add loudly so nothing wrong reaches the cart.
          if (!unit.variantId) throw { description: 'Could not resolve the product variants. Please reload and try again.' };
          var props = {};
          for (var s = 1; s <= unit.count; s++) {
            var slot = idx++;
            var ph = photos[slot] || {};
            props[self.photoProp + ' ' + s] = ph.url || '';
            if (ph.name) props[self.nameProp + ' ' + s] = ph.name;
            // Name font right after the name it styles (cart shows properties in insertion order).
            var ff = self.fields[slot];
            var fi = ff && ff.querySelector('[data-pp-font-value]');
            // A nameless input = the customer skipped the font -> the order gets NO font property (merchant picks).
            if (fi && !fi.disabled && fi.value && fi.name) props[self.fontProp + ' ' + s] = fi.value;
            if (self.engravings[slot]) {
              props[self.engProp + ' ' + s] = self.engravings[slot];   // this item's own message
              if (self.engFontProp && self.engFontChosen(slot)) props[self.engFontProp + ' ' + s] = self.engFontValueFor(slot);
            }
          }
          items.push({ id: unit.variantId, quantity: 1, properties: props });
        });
        if (!items.length) throw { description: 'Could not resolve the product variants. Please reload and try again.' };
        var engraved = this.engravedCountFor(total);   // fee must match the slots in THIS add, not a lagging activeCount
        if (engraved > 0 && this.engravingVariant) {
          items.push({ id: parseInt(this.engravingVariant, 10), quantity: this.engravingPerItem ? engraved : 1 });   // charge only engraved items
        }
        var body = { items: items };
        body.sections = sectionId ? [sectionId, 'cart-icon-bubble'] : ['cart-icon-bubble'];   // bubble re-render covers the empty->1 case (no element to update otherwise)
        body.sections_url = window.location.pathname;
        var r = await fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        var d = await r.json();
        if (!r.ok) throw d;
        if (goCheckout) { window.location.href = ROOT + 'checkout'; return; }   // skip-cart button: continue to checkout
        var html = d && d.sections && d.sections[sectionId];
        this.refreshDrawer(html, sectionId);
        this.refreshCartBubble(d && d.sections && d.sections['cart-icon-bubble']);
        this.updateCartCount();
        this.openDrawer();
      } catch (err) {
        this.flashError((err && (err.description || err.message)) || 'Could not add to cart. Please try again.');
      } finally {
        this._addBusy = false;
        this.setLoading(false);
      }
    }

    cartSectionId() {
      var drawer = document.querySelector('cart-drawer');
      var wrap = drawer && drawer.closest('[id^="shopify-section-"]');
      return wrap ? wrap.id.replace('shopify-section-', '') : null;
    }

    setLoading(on) {
      if (this._extBtn) {   // the add was started from an outside button (sticky ATC / skip-cart) — spin that one too
        this._extBtn.toggleAttribute('aria-busy', on);
        var esp = this._extBtn.querySelector('.loading-overlay__spinner');
        if (esp) esp.classList.toggle('hidden', !on);
        this._extBtn.classList.toggle('loading', on);
        if (!on) this._extBtn = null;
      }
      var btn = this.form && this.form.querySelector('[name="add"]');
      if (!btn) return;
      btn.toggleAttribute('aria-busy', on);
      var spinner = btn.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.toggle('hidden', !on);
      btn.classList.toggle('loading', on);
    }

    async addWithEngraving(goCheckout) {
      this._addBusy = true;
      this.setLoading(true);
      var sectionId = this.cartSectionId();
      try {
        // 1) Engraving add-on FIRST — this validates availability. If it fails (e.g. the
        //    engraving product is out of stock), abort BEFORE adding the main product so the
        //    cart is never left half-done, and surface the reason instead of failing silently.
        var liveCount = this.selectedVariantUnitCount() || this.unitCountInputValue() || this.activeCount || 1;
        var engQty = this.engravingPerItem ? (this.engravedCountFor(liveCount) || 1) : 1;   // charge only engraved items, counted against the live selection
        var er = await fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(this.engravingVariant, 10), quantity: engQty }] })
        });
        var ed = await er.json();
        if (!er.ok) {
          this.flashError((ed && ed.description) || 'The engraving add-on could not be added — it may be out of stock. Make the engraving product available (turn on "continue selling when out of stock", or stop tracking its inventory).');
          this.setLoading(false);
          return;
        }
        var engKey = (ed && ed.items && ed.items[0] && ed.items[0].key) || (ed && ed.key) || null;

        // 2) Main product (+ photos, names, engraving property) via multipart FormData
        var fd = new FormData(this.form);
        fd.append('sections', sectionId ? sectionId + ',cart-icon-bubble' : 'cart-icon-bubble');
        fd.append('sections_url', window.location.pathname);
        var mr = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
        var md = await mr.json();
        if (!mr.ok) {
          // Main product failed AFTER the engraving line was added -> remove the orphan so the cart isn't left with a lone engraving line.
          if (engKey) { try { await fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: engKey, quantity: 0 }) }); } catch (e) {} }
          throw md;
        }

        if (goCheckout) { window.location.href = ROOT + 'checkout'; return; }   // skip-cart button: continue to checkout
        var html = md && md.sections && md.sections[sectionId];
        this.refreshDrawer(html, sectionId);
        this.refreshCartBubble(md && md.sections && md.sections['cart-icon-bubble']);
        this.updateCartCount();
        this.openDrawer();
      } catch (err) {
        this.flashError((err && (err.description || err.message)) || 'Could not add to cart. Please try again.');
      } finally {
        this._addBusy = false;
        this.setLoading(false);
      }
    }

    refreshDrawer(html, sectionId) {
      if (!html || !sectionId) return;
      var wrap = document.getElementById('shopify-section-' + sectionId);
      if (!wrap) return;
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.getElementById('shopify-section-' + sectionId) || doc.querySelector('.shopify-section');
        wrap.innerHTML = inner ? inner.innerHTML : html;   // unwrap the Section Rendering response so we don't nest a duplicate #shopify-section
      } catch (e) {
        wrap.innerHTML = html;
      }
    }

    openDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
      document.body.classList.remove('is-empty');
    }

    /* Replace the header badge with a server-rendered copy — the only way the badge APPEARS
       when the cart goes empty -> 1 (there is no element to update before that). */
    refreshCartBubble(html) {
      if (!html) return;
      var target = document.getElementById('cart-icon-bubble');
      if (!target) return;
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.shopify-section');
        if (inner) target.innerHTML = inner.innerHTML;
      } catch (e) {}
    }

    async updateCartCount() {
      try {
        var res = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
        var cart = await res.json();
        Array.prototype.forEach.call(document.querySelectorAll('.cart-count-bubble span, [data-cart-count], .cart-count'), function (el) {
          el.textContent = cart.item_count;
        });
      } catch (e) {}
    }

    /* ---------- helpers ---------- */
    flashError(msg) {
      // Announce to screen readers via our OWN live region (the theme's error span role is theme-dependent).
      if (!this._liveRegion) {
        this._liveRegion = document.createElement('div');
        this._liveRegion.setAttribute('role', 'alert');
        this._liveRegion.setAttribute('aria-live', 'assertive');
        this._liveRegion.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
        this.appendChild(this._liveRegion);
      }
      var lr = this._liveRegion;
      lr.textContent = '';
      setTimeout(function () { lr.textContent = msg; }, 30);   // reset+set so a repeat of the same message still announces
      var box = this.form && this.form.closest('product-form');
      var wrapper = box && box.querySelector('.product-form__error-message-wrapper');
      var span = box && box.querySelector('.product-form__error-message');
      if (wrapper && span) {
        span.textContent = msg;
        wrapper.removeAttribute('hidden');
        wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        window.alert(msg);
      }
    }
    show(el) { if (el) el.hidden = false; }
    hide(el) { if (el) el.hidden = true; }
  }

  customElements.define('product-personalizer', ProductPersonalizer);
})();
  } catch(e) { console.error(e); }
})();

})();
